import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import Tool, { addTabTitle, handleLocalStorage, returnSourceType, getFullscreenEnabled, routerJump } from '@/assets/js/utils.js';
import AgoraClient from '@/assets/js/rtc-client-ng';
import { controlDeviceBehavior, controlAudio, controlDevicePublish, controlDeviceAudioOrVideo } from '@/assets/js/attendUser.js';
import VolumeBar from '@/assets/js/volumeBar.js';
import axios from 'axios';
const nodeUrl = require('url');
const CancelToken = axios.CancelToken;
export default {
  data() {
    return {
      showMicMutedInfo: {
        show: false,
        title: 'micMutedInfo.title',
        hideSave: true,
        hideCancel: true,
        showGotIt: true,
        gotIt: 'micMutedInfo.ignore'
      },
      showUnread: false,
      rtilCodeKeyTypeVal: {},
      deviceDetailInfo: {
        show: false,
        title: 'common.details',
        save: 'authorizeOperation.ok'
      },
      detailObj: {},
      drawer: false,
      anywhereSettingShowMap: {},
      anyWhereRtilCodeObj: {},
      anyWhereRtilCodeIndex: '',
      anyWherePeerIds: {},
      anyWherePlatForms: {},
      anyWhereInfo: {
        show: false,
        rtilCode: ''
      },
      getDeviceRtc: null,
      lowNetworkTime: 0,
      lowNetwork: false,
      initAudioOnlyPopup: true,
      value: '',
      loadChatBox: true,
      pullLoading: false,
      isShare: false,
      rtcLoaded: false,
      showLeft: false,
      showNextPageIcon: true,
      groupPartyCode: '',
      groupId: '',
      shareRtilCode: '',
      selectMainWindow: '',
      rtc: {},
      shareRtc: null,
      devicesInfo: {
        cameraList: [],
        microphoneList: [],
        cameraId: '',
        microphoneId: ''
      },
      collaborateInfo: {
        show: false,
        title: 'personalInfo.Permission',
        save: 'personalInfo.accept',
        cancel: 'personalInfo.decline',
        info: {}
      },
      audioLevel: true,
      repeatInfo: {
        show: false,
        title: 'common.repeatJoin',
        save: 'authorizeOperation.ok'
      },
      groupInfo: {},
      encoderInfo: {
        visible: false,
        data: [],
        maxNumber: 1
      },
      anyWhereSettings: {},
      tagNameInfo: {},
      mainWindowInfo: {},
      behaviorInfo: {},
      allRList: [],
      userInfo: {},
      rtilCode: '',
      sourceIds: [],
      partyCodeList: [],
      allPartyMembers: [],
      rtilCodeList: [],
      nameCheck: false,
      freeTalk: false,
      liveLoading: false,
      nameInfo: {
        show: false,
        checkVal: '',
        title: 'galleryHost.nameOperation',
        save: 'authorizeOperation.ok',
        cancel: 'commonFunction.cancel'
      },
      pullStreamObj: {
        rid: '',
        status: 0,
        text: 'Send',
        rList: [],
        info: {}
      },
      sendPullStream: {
        pageNum: 1,
        pageSize: 20,
        living: true,
        offline: false,
        online: true,
        condition: ''
      },
      sendOutputStream: {
        pageNum: 1,
        pageSize: 400,
        living: true,
        offline: false,
        online: true,
        condition: ''
      },
      buttonInfo: {
        Text: 'Send',
        Status: 0
      },
      sendParmas: {
        groupId: '',
        pageNum: 1
      },
      searchTimer: null,
      searchPullStreamTimer: null,
      scroll: {
        distance: 15,
        directive: '.pullStreamDrop .el-scrollbar__wrap',
        onScroll: this.loadPullStreamList
      },
      outputInitiator: '',
      outputRtilCode: '',
      vfbVideoInfo: null,
      PartyLineRequest: null,
      updateStatusTimer: null,
      wsPageSTimer: null,
      onlineNumberTimer: null,
      pipsListFullScreen: false,
      sourceType: {
        show: false,
        type: '',
        currentRId: '',
        startType: '',
        params: {}
      },
      channels: {},
      rtilStatusObj: {},
      controlMutes: {},
      allAccountIdByRtilCode: {},
      batchMovePartyInfo: {
        show: false,
        rtilCodes: []
      },
      chatParty: '',
      hasShare: false,
      initShowCloseFullScreenBtn: false,
      clearFullScreenTimer: null,
      showCloseFullScreenBtn: false,
      movePips: {},
      setTagName: {
        show: false,
        tagName: ''
      },
      replaceInfo: {},
      groupTimer: null,
      enableNext: true,
      removeInfo: {
        isRemoving: false,
        rtilCode: '',
        partyCode: ''
      },
      movePartyInfo: {
        show: false
      },
      selectRtilCodes: {},
      selectModule: '',
      broadcasterInfo: null,
      rtcByRtilCode: {},
      remoteNetWorks: {},
      previewVisible: false,
      tipsInfo: {
        title: 'pushParticipantSource.switchLive',
        content: '',
        cancel: 'pushParticipantSource.cancel',
        save: 'pushParticipantSource.confirm',
        show: false
      },
      dailogInfo: {
        show: false,
        title: 'commonFunction.switchMainWindow',
        cancel: 'pushParticipantSource.cancel',
        save: 'pushParticipantSource.confirm'
      },
      mainWindowList: [{
        label: 'Source type',
        options: [{
          value: 'VFB',
          label: 'VFB (Receiver Video Return)'
        }, {
          value: 'PP',
          label: 'PP (Producer)'
        }, {
          value: 'Broadcaster',
          label: 'Broadcaster (Participants)'
        }, {
          value: 'shareScreen',
          label: 'Shared Screen'
        }]
      }],
      shareList: {},
      hadOpenWebCloud: false,
      degreeHost: {},
      cancel: {},
      voiceList: {},
      localVolume: 0,
      meInfo: {},
      loadNextPageing: false,
      selectFontName: '',
      fontName: [{
        val: 'Arial',
        label: 'Arial'
      }, {
        val: 'BBC Reith Sans Light',
        label: 'Reith Sans Light'
      }, {
        val: 'BBC Reith Sans Medium',
        label: 'Reith Sans Medium'
      }, {
        val: 'BBC Reith Sans XBold',
        label: 'Reith Sans XBold'
      }, {
        val: 'BBC Reith Serif Light',
        label: 'Reith Serif Light'
      }, {
        val: 'BBC Reith Serif Medium',
        label: 'Reith Serif Medium'
      }, {
        val: 'Reith Serif XBold',
        label: 'Reith Serif XBold'
      }, {
        val: 'BBC Reith Sans',
        label: 'Reith Sans'
      }, {
        val: 'BBC Reith Sans Cd',
        label: 'Reith Sans Cd'
      }, {
        val: 'BBC Reith Serif',
        label: 'Reith Serif'
      }, {
        val: 'SimSun',
        label: 'SimSun'
      }, {
        val: 'Nimbus Sans',
        label: 'Nimbus Sans'
      }],
      fillRuleIndex: 1,
      slotIndex: 1,
      uploadImageInfo: {
        title: this.$t('galleryHost.imageGallery'),
        visible: false,
        slotIndex: -1,
        partyCode: ''
      },
      hasGetTimeOffset: false,
      bestOffset: 0,
      sendMetadataTimer: {}
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      Config: state => state.config,
      loginInfo: state => state.loginInfo,
      currentPartyInfo: state => state.currentPartyInfo,
      logoGray: state => state.logoGray,
      groupLayout: state => state.groupLayout,
      ChannelMode: state => state.channelMode
    }),
    returnPreviewClass() {
      return this.previewVisible ? 'previewPopover show' : 'previewPopover hide';
    },
    returnSmallClass() {
      let _str = this.State.groupLayout.column >= 6 ? 'smallIcon' : '';
      if (!this.State.showFootBar) _str += ' notShowFootBar';
      return _str;
    },
    showRListWithLive() {
      let flag = false;
      if (this.State.groupLayout.layoutName != '7-7-80-80' && this.State.groupLayout.layoutName != '12-24-80-80' && this.State.groupLayout.layoutName != '6-24-80-80' && !this.pipsListFullScreen) {
        flag = true;
      }
      return flag;
    },
    headLayoutClass() {
      let _str = '';
      if (this.groupLayout.layout) _str = `layout-${this.groupLayout.layoutName}`;
      if (this.groupLayout.layout * this.groupLayout.column > 72) {
        _str = _str + ' ' + 'video72';
      }
      return _str;
    },
    showOutputBtn() {
      let flag = false;
      if (this.selectMainWindow && this.selectMainWindow == 'Share') {
        flag = true;
      }
      return flag;
    },
    operateList() {
      const obj = {};
      const _this = this;
      // 全屏模式下不显示任何操作
      if (this.pipsListFullScreen) return {};
      Object.keys(_this.channels).forEach(id => {
        if (_this.channels[id] && _this.channels[id].leave) return;
        if (_this.State.crewInfo.rtilCode == _this.userInfo.rtilCode) {
          if (_this.State.privateInfo.rtilCode == id) {
            obj[id] = ['rename', 'editTagName', 'replace', 'cancelPrivateConversation', 'moveParty'];
          } else {
            var _this$State$privateIn;
            if ((_this$State$privateIn = _this.State.privateInfoByOthers) !== null && _this$State$privateIn !== void 0 && _this$State$privateIn.length) {
              _this.State.privateInfoByOthers.forEach(v => {
                if (v.rtilCode == id && v.crewRtilCode != _this.userInfo) {
                  obj[id] = ['rename', 'editTagName', 'replace', 'moveParty'];
                } else {
                  obj[id] = ['rename', 'editTagName', 'replace', 'startPrivateConversation', 'moveParty', 'setting', 'removeParticipant'];
                  if (this.rtilCodeKeyTypeVal[id] === 'Web' || this.rtilCodeKeyTypeVal[id] === 'Anywhere' || this.rtilCodeKeyTypeVal[id] === 'App') {
                    obj[id] = obj[id].filter(val => val != 'setting');
                  }
                }
              });
            } else {
              obj[id] = ['rename', 'editTagName', 'replace', 'startPrivateConversation', 'moveParty', 'setting', 'removeParticipant'];
              if (this.rtilCodeKeyTypeVal[id] === 'Web' || this.rtilCodeKeyTypeVal[id] === 'Anywhere' || this.rtilCodeKeyTypeVal[id] === 'App') {
                obj[id] = obj[id].filter(val => val != 'setting');
              } else if (this.rtilCodeKeyTypeVal[id] === 'T' || this.rtilCodeKeyTypeVal[id] === 'R') {
                obj[id] = obj[id].filter(val => val != 'startPrivateConversation' && val != 'moveParty');
              }
            }
          }
        }
        if (_this.State.cameraStatus[id]) {
          obj[id] && obj[id].unshift('fullScreen');
        }
        if (_this.State.gallerySpeakerInfo && _this.State.gallerySpeakerInfo.id == id || _this.freeTalk) {
          // 被设置为speaker的人不可以被私聊
          obj[id] = obj[id].filter(val => val != 'startPrivateConversation' && val != 'cancelPrivateConversation');
        }
        if (_this.broadcasterInfo && _this.broadcasterInfo.id == id) {
          obj[id] = obj[id].filter(val => val != 'moveParty');
        }
        if (obj[id] && obj[id].includes('moveParty') && !_this.State.batchMoveParticipateList.includes(id)) {
          _this.State.batchMoveParticipateList.push(id);
        }
        if (this.anyWherePeerIds[id] && this.anyWherePlatForms[id] != '12' || this.rtilCodeKeyTypeVal[id] === 'App') obj[id] && obj[id].push('anyWhereSetting');
      });
      return obj;
    },
    returnTitle() {
      return this.isShare ? 'Share' : 'VFB';
    },
    enableLast() {
      let _str = '';
      if (this.sendParmas.pageNum <= 1) _str = 'not-allowed';
      return _str;
    }
  },
  watch: {
    'currentPartyInfo.code': function (newVal, oldVal) {
      this.calculatePIpListWidth();
      this.userInfo = {};
      this.initJoinFn(newVal);
    },
    'State.batchMoveParticipate': function (val) {
      this.batchMovePartyInfo.show = val;
      if (!val) {
        this.batchMovePartyInfo.rtilCodes = [];
        this.movePips = {};
      }
    },
    pipsListFullScreen: function (val) {
      if (val) {
        this.showCloseFullScreenBtn = true;
        this.initShowCloseFullScreenBtn = true;
        this.clearFullScreenTimer = setTimeout(() => {
          this.showCloseFullScreenBtn = false;
          this.initShowCloseFullScreenBtn = false;
        }, 1000 * 3);
      }
      if (!val) {
        clearTimeout(this.clearFullScreenTimer);
        this.clearFullScreenTimer = null;
        this.initShowCloseFullScreenBtn = true;
        this.showCloseFullScreenBtn = false;
      }
    }
  },
  async created() {
    /**
     * @params 重构新加代码开始
     */
    this.getDeviceRtc = new AgoraClient(this.callBack);
    this.devicesInfo = await this.getDeviceRtc.getDevice();
    if (!this.State.volumeBar) {
      this.State.volumeBar = new VolumeBar();
    }
    const URL = nodeUrl.parse(location.href, true);
    if (URL.query.id) {
      // 检查 partyCode 中是否包含字母
      const hasLetters = /[a-zA-Z]/.test(URL.query.id);
      const illegalPartyCode = hasLetters ? URL.query.id : '';
      URL.query.id = URL.query.id.replace(/[^0-9]/ig, ''); // 过滤掉非数字字符
      if (URL.query.id.length > 20 || URL.query.id.length < 9) {
        this.$message.error(this.$t('common.invalidPartyIdText'));
        return;
      }
      this.State.partyCode = URL.query.id;
      await this.checkParty(URL.query.id);
      this.getPartyInfo(URL.query.id, illegalPartyCode);
      this.getFillRuleIndex(URL.query.id);
      this.getRegion();
    }
    /**
     * @params 重构新加代码结束
     */
    window.addEventListener('resize', this.calculatePIpListWidth);
    this.getReceiverList(true);
    Bus.$on('showAddDeviceBox', () => {
      this.showV3List();
    });
    Bus.$on('setPartyTitle', v => {
      document.title = this.$t('common.partyTitle', {
        name: v.title
      });
    });
    Bus.$on('volumeList', volumeList => {
      volumeList.forEach(volume => {
        this.$set(this.voiceList, volume.uid, volume);
      });
    });
    Bus.$on('setOutput', v => {
      const {
        sourceType,
        outputInitiator,
        receiverId,
        rtilCode,
        receiverName
      } = v;
      this.outputRtilCode = v.rtilCode;
      this.State.outputCode = v.rtilCode;
      this.vfbVideoInfo = {
        rtilCode: rtilCode,
        id: rtilCode
      };
      if (sourceType != 'Participant' && sourceType != 'ShareScreen') {
        // 为了其他host页面可以清空状态
        if (sourceType === 'PGM') {
          this.value = receiverId;
        } else {
          this.value = receiverName;
        }
        this.selectMainWindow = receiverName;
        this.selectRid = receiverId;
        this.groupInfo.outputRid = v.receiverId;
        this.groupInfo.outputSourceType = v.sourceType;
        this.State.groupInfo.outputRid = v.receiverId;
      }
      if (sourceType == 'ShareScreen') {
        this.outputInitiator = outputInitiator;
        this.shareRtilCode = v.rtilCode;
        this.value = 'Share';
        this.selectMainWindow = 'Share';
        this.dealSubscribeVideo({
          id: v.rtilCode
        });
      }
      if (sourceType == 'Participant') {
        this.broadcasterInfo = v.info;
        this.State.galleryBroadcastInfo = v.info;
        this.value = 'Broadcaster';
        this.selectMainWindow = 'Broadcaster';
        this.buttonInfo.Status = 2;
        this.buttonInfo.Text = 'Stop';
      }
      // 因为后台推送和agora回调返回可能存在一个快慢的问题
      if (this.rtc[this.chatParty]._subscribeTrack[rtilCode]) {
        const obj = {};
        obj.id = rtilCode;
        obj.videoTrack = this.rtc[this.chatParty]._subscribeTrack[rtilCode].videoTrack;
        obj.audioTrack = this.rtc[this.chatParty]._subscribeTrack[rtilCode].audioTrack;
        this.vfbVideoInfo = obj;
      }
      // 为屏幕分享添加
      // if (this.localShareInfo[rtilCode] && this.channels[rtilCode]) {
      //   this.vfbVideoInfo = this.channels[rtilCode]
      // }
    });

    Bus.$on('cancelOutput', v => {
      const {
        sourceType
      } = v;
      this.outputRtilCode = '';
      this.State.outputCode = '';
      this.vfbVideoInfo = null;
      if (sourceType != 'Participant' && sourceType != 'ShareScreen') {
        // 为了其他host页面可以清空状态
        this.groupInfo.outputType = '';
        this.sourceType.type = '';
        this.sourceType.show = false;
        this.sourceType.startType = '';
        this.vfbVideoInfo = null;
        this.buttonInfo.Status = 1;
        this.buttonInfo.Text = 'Send';
        this.groupInfo.outputRid = '';
        this.State.groupInfo.outputRid = '';
        if (this.State.joinInfo) {
          this.State.joinInfo.status.receiverOutput = '';
        }
      }
      if (sourceType == 'Participant') {
        this.broadcasterInfo = null;
        this.State.galleryBroadcastInfo = null;
        this.value = '';
        this.selectMainWindow = '';
        this.buttonInfo.Status = 0;
        this.buttonInfo.Text = 'Send';
      }
      if (sourceType == 'ShareScreen') {
        this.outputInitiator = '';
        this.vfbVideoInfo = null;
        this.shareRtilCode = '';
        this.value = '';
        this.selectMainWindow = '';
      }
    });
    Bus.$on('rtilLiveStatus', v => {
      this.rtilStatusObj = v;
    });
    // 获取rtil对应的R的状态
    Bus.$off('pageSerBusCallback');
    Bus.$on('pageSerBusCallback', v => {
      if (v.partyCode != this.groupPartyCode) return;
      this.pageSerBusCallback(v);
      this.getParOnlineNumber(v);
    });
    Bus.$on('wholePageFullScreen', data => {
      this.pipsListFullScreen = data;
    });
    Bus.$on('selectAllPipMove', v => {
      // 只对目前已有的与会者进行操作，后加入的不处理
      if (v.type == 'all') {
        Object.keys(this.operateList).forEach(id => {
          if (this.operateList[id].includes('moveParty') && this.shareRtilCode != id && this.outputRtilCode != id) {
            this.$set(this.movePips, id, v.status);
            this.attendCallback({
              type: 'moveParty',
              id: id,
              status: v.status,
              sign: 'batch'
            });
          }
        });
      }
    });
    Bus.$on('groupRtilCodes', result => {
      let btn = false;
      const nextPage = result.pageRtilCodes[this.sendParmas.pageNum + 1];
      if (nextPage) {
        nextPage.forEach(v => {
          if (v >= 0) btn = true;
        });
        if (!btn) {
          this.enableNext = false;
        } else {
          this.enableNext = true;
        }
      }
      if (this.groupTimer) clearTimeout(this.groupTimer);
      this.groupTimer = setTimeout(() => {
        const currentPageRtilList = result.pageRtilCodes[this.sendParmas.pageNum];
        currentPageRtilList && currentPageRtilList.forEach((v, k) => {
          if (this.rtilCodeList[k] != v) {
            this.$set(this.rtilCodeList, k, v);
            this.rtilCodeList = [...new Set(this.rtilCodeList)];
            this.State.galleryAllGroupRtilCodes = this.rtilCodeList;
            // this.removeInfo.rtilCode && this.$delete(this.channels, this.removeInfo.rtilCode)
            this.removeInfo.isRemoving = false;
          }
        });
      }, 1000);
    });
    Bus.$on('endParty', v => {
      this.value = '';
      this.buttonInfo.Text = 'Send';
      this.selectMainWindow = '';
      this.buttonInfo.Status = 1;
      this.pullStreamObj.status = 0;
      this.pullStreamObj.text = 'Send';
      this.State.hadPullStream = false;
      this.pullStreamObj.rid = '';
      this.pullStreamObj.info = {};
      this.selectRid = '';
      this.groupInfo.outputRid = '';
      this.groupInfo.pullStreamReceiverId = '';
      this.broadcasterInfo = null;
      this.shareRtc && this.shareRtc.leave();
      this.loadChatBox = false;
      this.fillRuleIndex = 1;
      this.slotIndex = 0;
      this.clearStatus();
      routerJump('remove', {
        type: 'end'
      });
    });
    Bus.$on('setBehaviors', v => {
      const behaviors = v.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          this.$set(this.behaviorInfo, val.mark, val.value);
        }
        if (val.key == 'tagName') {
          this.$set(this.tagNameInfo, val.mark, val.value);
        }
        if (this.anyWhereSettings[val.mark] && val.key in this.anyWhereSettings[val.mark]) {
          if (val.key === 'whiteBalance') {
            const parsedValue = JSON.parse(val.value);
            this.$set(this.anyWhereSettings[val.mark], val.key, parsedValue);
          } else {
            // Directly set the value for other keys
            this.$set(this.anyWhereSettings[val.mark], val.key, val.value);
          }
        }
      });
    });
    Bus.$on('updateLayout', layout => {
      if (!this.userInfo.rtilCode) return;
      this.updateLayout(layout, this.userInfo.rtilCode);
    });
    Bus.$on('configPartyList', v => {
      if (v) {
        this.showLeft = false;
      } else {
        setTimeout(() => {
          if (this.userInfo.layoutName != '7-7-80-80' && this.userInfo.layoutName != '12-24-80-80' && this.userInfo.layoutName != '6-24-80-80') {
            this.showLeft = true;
          }
        }, 200);
      }
    });
    Bus.$on('startPrivateConversation', async v => {
      if (!this.$route.name.includes('group') || JSON.stringify(this.userInfo) == '{}') return;
      const {
        realPartyCode
      } = v;
      const realRtc = this.rtc[realPartyCode];
      const externalRtc = this.rtc[this.chatParty];
      if (realRtc && realRtc._localAudioTrack && v.crewRtilCode == this.userInfo.rtilCode && this.State.micStatus[this.userInfo.rtilCode]) {
        controlDevicePublish(realRtc, 'publish', [realRtc._localAudioTrack]);
        // 还要把特许的external里面的声音禁掉
        controlDevicePublish(externalRtc, 'unpublish', [externalRtc._localAudioTrack]);
      }
      // 先判断是不是自己的私聊
      if (v.crewRtilCode == this.userInfo.rtilCode) {
        this.State.privateInfo = v;
        // 需要mute掉其他与会者和host controls mute
        this.rtilCodeList.forEach(id => {
          if (id != v.rtilCode) {
            this.$set(this.controlMutes, id, true);
          }
        });
        this.userInfo.managerRtils.forEach(id => {
          if (id != this.userInfo.rtilCode) {
            this.$set(this.controlMutes, id, true);
          }
        });
      } else {
        var _this$State$privateIn2;
        if (!((_this$State$privateIn2 = this.State.privateInfoByOthers) !== null && _this$State$privateIn2 !== void 0 && _this$State$privateIn2.length)) {
          this.State.privateInfoByOthers.push(v);
          this.$set(this.controlMutes, v.crewRtilCode, true);
          this.$set(this.controlMutes, v.rtilCode, true);
          return;
        }
        this.State.privateInfoByOthers.forEach(val => {
          if (v.crewRtilCode != val.crewRtilCode || v.rtilCode != val.rtilCode) {
            this.State.privateInfoByOthers.push(v);
            this.$set(this.controlMutes, v.crewRtilCode, true);
            this.$set(this.controlMutes, v.rtilCode, true);
          }
        });
      }
    });
    Bus.$on('cancelPrivateConversation', async v => {
      if (!this.$route.name.includes('group')) return;
      const {
        realPartyCode
      } = v;
      const realRtc = this.rtc[realPartyCode];
      const externalRtc = this.rtc[this.chatParty];
      if (realRtc && realRtc._localAudioTrack && v.crewRtilCode == this.userInfo.rtilCode) {
        controlDevicePublish(realRtc, 'unpublish', [realRtc._localAudioTrack]);
        // 还要把特殊的external里面的声音恢复,再根据页面是否静音去做处理
        if (this.State.micStatus[this.userInfo.rtilCode]) {
          if (externalRtc._localAudioTrack) {
            controlDevicePublish(externalRtc, 'publish', [externalRtc._localAudioTrack]);
          } else {
            controlAudio(externalRtc, this.devicesInfo, true);
          }
        }
      }
      // 先判断是不是自己的私聊
      if (v.crewRtilCode == this.userInfo.rtilCode) {
        this.State.privateInfo = {};
        // 需要恢复掉其他与会者和host controls mute,（在私聊的其他与会者和host不可以恢复mute）
        const otherPraivateRtilCode = this.State.privateInfoByOthers.map(v => v.rtilCode + '');
        this.rtilCodeList.forEach(v => {
          if (v != v.rtilCode && !otherPraivateRtilCode.includes(v + '')) {
            // （在私聊的其他与会者和host不可以恢复mute）
            this.$set(this.controlMutes, v, '');
          }
        });
      } else {
        this.State.privateInfoByOthers.forEach((val, index) => {
          if (v.crewRtilCode == val.crewRtilCode && v.rtilCode == val.rtilCode) {
            this.State.privateInfoByOthers.splice(index, 1);
            this.$set(this.controlMutes, v.crewRtilCode, '');
          }
        });
        if (this.State.privateInfo.crewRtilCode) {
          // 如果自己还存在私聊，则还需要继续mute
          this.$set(this.controlMutes, v.rtilCode, true);
          this.$set(this.controlMutes, v.crewRtilCode, true);
        } else {
          // 没有私聊存在，则恢复mute
          this.$set(this.controlMutes, v.rtilCode, '');
          this.$set(this.controlMutes, v.crewRtilCode, '');
        }
      }
    });
    Bus.$on('setSpeaker', v => {
      if (!this.$route.name.includes('group')) return;
      this.State.gallerySpeakerInfo = v.info;
      const {
        rtilCode
      } = v.info ? v.info : v;
      this.lastSpeakerRtilCode = rtilCode;
      const _this = this;
      // 因为后台推送和agora回调返回可能存在一个快慢的问题
      if (_this.State.galleryExternalChannels[rtilCode]) {
        this.$set(this.channels, rtilCode, this.State.gallerySpeakerInfo);
      }
    });
    Bus.$on('cancelSpeaker', v => {
      if (!this.$route.name.includes('group')) return;
      this.State.gallerySpeakerInfo = null;
    });
    Bus.$on('setFreeTalk', () => {
      this.freeTalk = true;
    });
    Bus.$on('cancelFreeTalk', () => {
      this.freeTalk = false;
    });
    Bus.$on('collaborateInvite', result => {
      const {
        collaborateUserId,
        status,
        toEmail
      } = result;
      if (collaborateUserId == this.State.loginInfo.id) {
        status === 0 ? this.collaborateInfo.show = true : this.collaborateInfo.show = false;
        if (status === 0) {
          this.collaborateInfo.info = result;
        } else if (status === 2) {
          this.collaborateInfo.info = {};
        }
      } else {
        if (status === 1) {
          this.$message.success(toEmail + this.$t('personalInfo.accepted'));
        } else if (status === 2) {
          this.$message.warning(toEmail + this.$t('personalInfo.refuseInvite'));
        }
      }
    });
    Bus.$on('setLoginScreenButton', async val => {
      const {
        buttonType,
        operationType
      } = val.buttonStatus;
      if (buttonType === 7) {
        if (operationType) {
          this.hadOpenWebCloud = true;
          for (const k in this.rtc) {
            this.rtc[k] && (await this.rtc[k].leave());
          }
          this.joinPartyLine();
        } else {
          this.hadOpenWebCloud = false;
          for (const k in this.rtc) {
            this.rtc[k] && (await this.rtc[k].leave('closeCLoudProxy'));
          }
          this.joinPartyLine();
        }
      } else if (buttonType === 17) {
        if (operationType === 0) {
          this.audioLevel = true;
        } else {
          this.audioLevel = false;
        }
      }
    });
    Bus.$on('flipVideo', v => {
      // 与会者getList(与会者、anywhere)
      this.$set(this.degreeHost, v.rtilCode, v.degree);
    });
    Bus.$on('stopPullStream', v => {
      this.pullStreamObj.status = 1;
      this.pullStreamObj.text = 'Send';
    });
    // 处理audioOnly
    Bus.$on('subscribeAudioControl', val => {
      if (val) {
        // 2禁用
        if (val == 2) {
          // mainWindow 特殊处理
          if (!this.shareList.length) {
            if (this.vfbVideoInfo && !this.State.localShareInfo[this.vfbVideoInfo.id]) {
              var _this$rtc$this$userIn, _this$userInfo$status;
              (_this$rtc$this$userIn = this.rtc[(_this$userInfo$status = this.userInfo.status) === null || _this$userInfo$status === void 0 ? void 0 : _this$userInfo$status.externalOutputParty]) === null || _this$rtc$this$userIn === void 0 ? void 0 : _this$rtc$this$userIn.subscribe(this.vfbVideoInfo.id, 'video');
              this.vfbVideoInfo.hasUnsubscribe = false;
            }
            // 与会者 特殊处理
            Object.keys(this.channels).forEach(rtilCode => {
              var _this$channels$rtilCo;
              if (rtilCode != this.userInfo.rtilCode && (_this$channels$rtilCo = this.channels[rtilCode]) !== null && _this$channels$rtilCo !== void 0 && _this$channels$rtilCo.hasUnsubscribe) {
                var _this$rtc$this$userIn2;
                (_this$rtc$this$userIn2 = this.rtc[this.userInfo.realPartyList[0].realPartyCode]) === null || _this$rtc$this$userIn2 === void 0 ? void 0 : _this$rtc$this$userIn2.subscribe(rtilCode, 'video', 'unExecuteCallback');
                this.channels[rtilCode].hasUnsubscribe = false;
              }
            });
            // 分享特殊处理
            Object.keys(this.shareList).forEach(rtilCode => {
              if (rtilCode != this.userInfo.rtilCode && this.shareList[rtilCode]) {
                var _this$rtc$this$userIn3, _this$userInfo$status2;
                (_this$rtc$this$userIn3 = this.rtc[(_this$userInfo$status2 = this.userInfo.status) === null || _this$userInfo$status2 === void 0 ? void 0 : _this$userInfo$status2.externalOutputParty]) === null || _this$rtc$this$userIn3 === void 0 ? void 0 : _this$rtc$this$userIn3.subscribe(rtilCode, 'video', 'unExecuteCallback');
                if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = false;
              }
            });
            return;
          } // 2 是关闭 audio-only 状态不用订阅
        }
        // 1 alltheTime
        // mainWindow 特殊处理
        if (!this.shareList.length) {
          if (this.vfbVideoInfo && !this.State.localShareInfo[this.vfbVideoInfo.id]) {
            // 需要判断当前的 mainWindow是否处于选中状态，选中需要订阅
            if (!this.State.checkMainWindow) {
              var _this$userInfo$status3;
              this.rtc[(_this$userInfo$status3 = this.userInfo.status) === null || _this$userInfo$status3 === void 0 ? void 0 : _this$userInfo$status3.externalOutputParty].unsubscribe(this.vfbVideoInfo.id, 'video');
              this.vfbVideoInfo.hasUnsubscribe = true;
            }
          }
        }
        // 与会者 特殊处理
        Object.keys(this.channels).forEach(rtilCode => {
          var _this$channels$rtilCo2;
          if (rtilCode != this.userInfo.rtilCode && !((_this$channels$rtilCo2 = this.channels[rtilCode]) !== null && _this$channels$rtilCo2 !== void 0 && _this$channels$rtilCo2.hasUnsubscribe)) {
            this.rtc[this.userInfo.realPartyList[0].realPartyCode].unsubscribe(rtilCode, 'video');
            this.$set(this.channels[rtilCode], 'hasUnsubscribe', true);
          }
        });
        // // 分享 特殊处理
        Object.keys(this.shareList).forEach(rtilCode => {
          if (rtilCode != this.userInfo.rtilCode && this.shareList[rtilCode]) {
            if (this.shareList[rtilCode]) {
              if (!this.State.checkMainWindow) {
                var _this$userInfo$status4;
                this.rtc[(_this$userInfo$status4 = this.userInfo.status) === null || _this$userInfo$status4 === void 0 ? void 0 : _this$userInfo$status4.externalOutputParty].unsubscribe(rtilCode, 'video', 'unExecuteCallback');
                if (this.vfbVideoInfo) {
                  this.vfbVideoInfo.hasUnsubscribe = true;
                }
              }
            }
          }
        });
      } else {
        // 0 自动状态

        // mainWindow 特殊处理
        if (!this.shareList.length) {
          if (this.vfbVideoInfo && !this.State.localShareInfo[this.vfbVideoInfo.id]) {
            // 需要判断当前的 mainWindow是否处于选中状态，选中需要订阅
            // 分为两种情况一种网络较好(可以不取参考checkbox)，另外一种是网络不好需要参考checkbox
            if (!this.State.inAudioOnlyStatus) {
              var _this$rtc$this$userIn4, _this$userInfo$status5;
              (_this$rtc$this$userIn4 = this.rtc[(_this$userInfo$status5 = this.userInfo.status) === null || _this$userInfo$status5 === void 0 ? void 0 : _this$userInfo$status5.externalOutputParty]) === null || _this$rtc$this$userIn4 === void 0 ? void 0 : _this$rtc$this$userIn4.subscribe(this.vfbVideoInfo.id, 'video', 'unExecuteCallback');
              this.vfbVideoInfo.hasUnsubscribe = false;
            } else {
              if (this.State.checkMainWindow) {
                var _this$rtc$this$userIn5, _this$userInfo$status6;
                (_this$rtc$this$userIn5 = this.rtc[(_this$userInfo$status6 = this.userInfo.status) === null || _this$userInfo$status6 === void 0 ? void 0 : _this$userInfo$status6.externalOutputParty]) === null || _this$rtc$this$userIn5 === void 0 ? void 0 : _this$rtc$this$userIn5.subscribe(this.vfbVideoInfo.id, 'video', 'unExecuteCallback');
                this.vfbVideoInfo.hasUnsubscribe = false;
              }
            }
          }
        }
        // 与会者 特殊处理
        Object.keys(this.channels).forEach(rtilCode => {
          var _this$channels$rtilCo3;
          if (rtilCode != this.userInfo.rtilCode && (_this$channels$rtilCo3 = this.channels[rtilCode]) !== null && _this$channels$rtilCo3 !== void 0 && _this$channels$rtilCo3.hasUnsubscribe) {
            var _this$rtc$this$userIn6;
            (_this$rtc$this$userIn6 = this.rtc[this.userInfo.realPartyList[0].realPartyCode]) === null || _this$rtc$this$userIn6 === void 0 ? void 0 : _this$rtc$this$userIn6.subscribe(rtilCode, 'video', 'unExecuteCallback');
            this.channels[rtilCode].hasUnsubscribe = false;
          }
        });
        // 分享特殊处理
        Object.keys(this.shareList).forEach(rtilCode => {
          if (rtilCode != this.userInfo.rtilCode && this.shareList[rtilCode]) {
            if (this.shareList[rtilCode]) {
              if (!this.State.inAudioOnlyStatus) {
                var _this$rtc$this$userIn7, _this$userInfo$status7;
                (_this$rtc$this$userIn7 = this.rtc[(_this$userInfo$status7 = this.userInfo.status) === null || _this$userInfo$status7 === void 0 ? void 0 : _this$userInfo$status7.externalOutputParty]) === null || _this$rtc$this$userIn7 === void 0 ? void 0 : _this$rtc$this$userIn7.subscribe(rtilCode, 'video', 'unExecuteCallback');
                if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = false;
              } else {
                if (this.State.checkMainWindow) {
                  var _this$rtc$this$userIn8, _this$userInfo$status8;
                  (_this$rtc$this$userIn8 = this.rtc[(_this$userInfo$status8 = this.userInfo.status) === null || _this$userInfo$status8 === void 0 ? void 0 : _this$userInfo$status8.externalOutputParty]) === null || _this$rtc$this$userIn8 === void 0 ? void 0 : _this$rtc$this$userIn8.subscribe(rtilCode, 'video', 'unExecuteCallback');
                  if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = false;
                }
              }
            }
          }
        });
      }
    });
    // 处理勾选mainWindowAudioOnly
    Bus.$on('dealMainAudioOnly', val => {
      if (this.outputRtilCode) {
        // 先判断当前处于哪种模式下
        if (this.State.audioType) {
          if (this.State.audioType == 2) {
            var _this$rtc$this$userIn9, _this$userInfo$status9;
            (_this$rtc$this$userIn9 = this.rtc[(_this$userInfo$status9 = this.userInfo.status) === null || _this$userInfo$status9 === void 0 ? void 0 : _this$userInfo$status9.externalOutputParty]) === null || _this$rtc$this$userIn9 === void 0 ? void 0 : _this$rtc$this$userIn9.subscribe(this.outputRtilCode, 'video', 'unExecuteCallback');
            if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = false;
          } else {
            if (val) {
              var _this$rtc$this$userIn10, _this$userInfo$status10;
              (_this$rtc$this$userIn10 = this.rtc[(_this$userInfo$status10 = this.userInfo.status) === null || _this$userInfo$status10 === void 0 ? void 0 : _this$userInfo$status10.externalOutputParty]) === null || _this$rtc$this$userIn10 === void 0 ? void 0 : _this$rtc$this$userIn10.subscribe(this.outputRtilCode, 'video', 'unExecuteCallback');
              if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = false;
            } else {
              var _this$rtc$this$userIn11, _this$userInfo$status11;
              (_this$rtc$this$userIn11 = this.rtc[(_this$userInfo$status11 = this.userInfo.status) === null || _this$userInfo$status11 === void 0 ? void 0 : _this$userInfo$status11.externalOutputParty]) === null || _this$rtc$this$userIn11 === void 0 ? void 0 : _this$rtc$this$userIn11.unsubscribe(this.outputRtilCode, 'video', 'unExecuteCallback');
              if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = true;
            }
          }
        } else {
          // 如果是 auto audio-only 需要先判断当前是否处于 audio-only 状态中
          if (!this.State.inAudioOnlyStatus) {
            var _this$rtc$this$userIn12, _this$userInfo$status12;
            (_this$rtc$this$userIn12 = this.rtc[(_this$userInfo$status12 = this.userInfo.status) === null || _this$userInfo$status12 === void 0 ? void 0 : _this$userInfo$status12.externalOutputParty]) === null || _this$rtc$this$userIn12 === void 0 ? void 0 : _this$rtc$this$userIn12.subscribe(this.outputRtilCode, 'video', 'unExecuteCallback');
            if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = false;
          } else {
            if (val) {
              var _this$rtc$this$userIn13, _this$userInfo$status13;
              (_this$rtc$this$userIn13 = this.rtc[(_this$userInfo$status13 = this.userInfo.status) === null || _this$userInfo$status13 === void 0 ? void 0 : _this$userInfo$status13.externalOutputParty]) === null || _this$rtc$this$userIn13 === void 0 ? void 0 : _this$rtc$this$userIn13.subscribe(this.outputRtilCode, 'video', 'unExecuteCallback');
              if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = false;
            } else {
              var _this$rtc$this$userIn14, _this$userInfo$status14;
              (_this$rtc$this$userIn14 = this.rtc[(_this$userInfo$status14 = this.userInfo.status) === null || _this$userInfo$status14 === void 0 ? void 0 : _this$userInfo$status14.externalOutputParty]) === null || _this$rtc$this$userIn14 === void 0 ? void 0 : _this$rtc$this$userIn14.unsubscribe(this.outputRtilCode, 'video', 'unExecuteCallback');
              if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = true;
            }
          }
        }
      }
    });
    Bus.$on('downlinkNetworkQuality', val => {
      // 判断当前所选择的 audio-only 模式，如果是 all time 的话则不需要走这段逻辑
      if (this.State.audioType || this.State.audioType == 2) return;
      // 当连续8s处于若网时，则改为只订阅音频流,连续6s状态良好则恢复订阅视频流
      if (val < 4) {
        if (this.lowNetworkTime > 0) {
          this.lowNetworkTime--;
        } else {
          this.lowNetworkTime = 0;
        }
        if (this.lowNetwork && this.lowNetworkTime === 0) {
          this.lowNetwork = false;
          Object.keys(this.channels).forEach(rtilCode => {
            var _this$channels$rtilCo4;
            if (rtilCode != this.userInfo.rtilCode && (_this$channels$rtilCo4 = this.channels[rtilCode]) !== null && _this$channels$rtilCo4 !== void 0 && _this$channels$rtilCo4.hasUnsubscribe) {
              var _this$rtc$this$userIn15, _this$userInfo$status15, _this$rtc$this$userIn16;
              (_this$rtc$this$userIn15 = this.rtc[(_this$userInfo$status15 = this.userInfo.status) === null || _this$userInfo$status15 === void 0 ? void 0 : _this$userInfo$status15.externalOutputParty]) === null || _this$rtc$this$userIn15 === void 0 ? void 0 : _this$rtc$this$userIn15.subscribe(rtilCode, 'video', 'unExecuteCallback');
              (_this$rtc$this$userIn16 = this.rtc[this.userInfo.realPartyList[0].realPartyCode]) === null || _this$rtc$this$userIn16 === void 0 ? void 0 : _this$rtc$this$userIn16.subscribe(rtilCode, 'video');
              this.channels[rtilCode].hasUnsubscribe = false;
              if (this.vfbVideoInfo) {
                this.vfbVideoInfo.hasUnsubscribe = false;
              }
            }
          });
          this.State.inAudioOnlyStatus = false;
          this.initAudioOnlyPopup = true;
        }
      } else {
        if (this.lowNetworkTime < 3) {
          this.lowNetworkTime++;
        } else if (this.lowNetworkTime === 3) {
          this.lowNetwork = true;
        }
        if (this.lowNetwork) {
          Object.keys(this.channels).forEach(rtilCode => {
            var _this$channels$rtilCo5;
            if (rtilCode != this.userInfo.rtilCode && !((_this$channels$rtilCo5 = this.channels[rtilCode]) !== null && _this$channels$rtilCo5 !== void 0 && _this$channels$rtilCo5.hasUnsubscribe)) {
              if (this.outputRtilCode == rtilCode && !this.State.checkMainWindow || this.shareList[rtilCode] && !this.State.checkMainWindow) {
                var _this$userInfo$status16;
                this.rtc[(_this$userInfo$status16 = this.userInfo.status) === null || _this$userInfo$status16 === void 0 ? void 0 : _this$userInfo$status16.externalOutputParty].unsubscribe(rtilCode, 'video');
                this.rtc[this.userInfo.realPartyList[0].realPartyCode].unsubscribe(rtilCode, 'video');
                this.channels[rtilCode].hasUnsubscribe = true;
                if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = true;
              } else {
                // this.rtc[this.userInfo.status.externalOutputParty].unsubscribe(rtilCode, 'video')
                this.rtc[this.userInfo.realPartyList[0].realPartyCode].unsubscribe(rtilCode, 'video');
                this.channels[rtilCode].hasUnsubscribe = true;
                // this.vfbVideoInfo.hasUnsubscribe = true
              }
            }
          });

          this.State.inAudioOnlyStatus = true;
          if (this.initAudioOnlyPopup) {
            this.initAudioOnlyPopup = false;
            this.$message.success(this.$t('netWorkStatus.poorNetworkPopup'));
          }
        }
      }
    });
    Bus.$on('controlBehavior', v => {
      const {
        rtilCode,
        behavior
      } = v;
      const {
        key,
        value
      } = behavior;
      if (key == 'nickName' && this.behaviorInfo[rtilCode]) {
        this.behaviorInfo[rtilCode] = value;
      }
    });
    Bus.$on('responseControlBehavior', v => {
      const {
        key,
        rtilCode,
        responseCode,
        senderRtilCode
      } = v;
      // 为了兼容anywhere，目前anywhere不会传递host的rtilCode，所以直接提示，之后添加就给rtiCode == -1添加去掉
      if (rtilCode == this.userInfo.rtilCode || rtilCode == -1) {
        if (key === 'camera') {
          if (responseCode == 2) {
            this.$set(this.State.cameraStatus, senderRtilCode, false);
            this.$message.warning(this.$t('kioskHost.requestDeny'));
          }
          if (responseCode == 3) {
            this.$message.warning(this.$t('common.operationCameraFailed'));
          }
        }
        if (key == 'mic') {
          if (responseCode == 3) {
            this.$message.warning(this.$t('common.operationMicroFailed'));
          }
        }
      }
    });
    Bus.$on('changeSlotIndex', val => {
      this.slotIndex = val;
    });
    Bus.$on('changeFillRule', val => {
      this.fillRuleIndex = val;
      this.slotIndex = 0;
    });
    Bus.$on('showUplodImageBox', () => {
      this.uploadImageInfo.slotIndex = -1;
      this.uploadImageInfo.visible = !this.uploadImageInfo.visible;
    });
  },
  methods: {
    getUploadImageInfo(partyCode) {
      this.axios.get('/partyline-backend/dictionary', {
        params: {
          partyCode,
          key: 'galleryImageSlotIndex'
        }
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.State.imagePositionInfo = res.data.result ? JSON.parse(res.data.result) : {};
          Object.keys(this.State.imagePositionInfo).forEach(key => {
            this.$set(this.behaviorInfo, key, this.State.imagePositionInfo[key].imageName);
          });
        }
      });
    },
    openMicMuted() {
      window.open('ms-settings:sound', '_blank');
    },
    getFillRuleIndex(partyCode) {
      this.axios.get(`/partyline-backend/group/noLogin/getFullInRule/${partyCode}`).then(res => {
        const result = res.data;
        if (result.errorCode === '0x0') {
          this.fillRuleIndex = result.result;
        }
      });
    },
    showV3List() {
      this.drawer = true;
    },
    closeAnywherePreview() {
      // 恢复的gallery列表对象赋值给channels
      this.$set(this.channels, this.anyWhereInfo.rtilCode, this.anyWhereRtilCodeObj);
      this.$set(this.anywhereSettingShowMap, this.anyWhereInfo.rtilCode, false);
      this.anyWhereInfo.rtilCode = '';
      this.vfbVideoInfo = null;
    },
    async checkParty(partyCode) {
      if (!partyCode) return;
      // 检查 partyCode 中是否包含字母
      const hasLetters = /[a-zA-Z]/.test(partyCode);
      partyCode = partyCode.replace(/[^0-9]/ig, ''); // 过滤掉非数字字符
      if (partyCode.length > 20 || partyCode.length < 9 || hasLetters) {
        this.$message.error(this.$t('common.invalidPartyIdText'));
        return;
      }
      const result = await this.axios.get('/partyline-backend/party/noLogin/check', {
        params: {
          partyCode: Number(partyCode),
          clientType: 0
        }
      }).then(res => {
        var _res$data;
        if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.errorCode) == '0x0') {
          return res.data.result;
        }
      });
      if (!result || !result.owner && !result.coHost && this.State.participateChannelMode[result.channelModel]) {
        // 不是登录人的party，已与会者身份进入
        routerJump('preview', {
          id: partyCode
        });
      }
    },
    // 处理初始化及其他 audio-only 时的视频订阅问题
    dealSubscribeVideo(payload) {
      const _this = this;
      const {
        id
      } = payload;
      // 处理mainWindow初始化&&分享屏幕
      if (this.outputRtilCode && this.outputRtilCode == id) {
        // 先判断当前 audio-only 选择的模式
        if (this.State.audioType) {
          if (this.State.checkMainWindow || this.State.audioType == 2) {
            var _this$rtc$this$userIn17, _this$userInfo$status17;
            if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = false;
            (_this$rtc$this$userIn17 = this.rtc[(_this$userInfo$status17 = this.userInfo.status) === null || _this$userInfo$status17 === void 0 ? void 0 : _this$userInfo$status17.externalOutputParty]) === null || _this$rtc$this$userIn17 === void 0 ? void 0 : _this$rtc$this$userIn17.subscribe(id, 'video', 'unExecuteCallback');
          } else {
            if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = true;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            if (this.State.checkMainWindow) {
              var _this$rtc$this$userIn18, _this$userInfo$status18;
              if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = false;
              (_this$rtc$this$userIn18 = this.rtc[(_this$userInfo$status18 = this.userInfo.status) === null || _this$userInfo$status18 === void 0 ? void 0 : _this$userInfo$status18.externalOutputParty]) === null || _this$rtc$this$userIn18 === void 0 ? void 0 : _this$rtc$this$userIn18.subscribe(id, 'video', 'unExecuteCallback');
            } else {
              if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = true;
            }
          } else {
            var _this$rtc$this$userIn19, _this$userInfo$status19;
            if (this.vfbVideoInfo) this.vfbVideoInfo.hasUnsubscribe = false;
            (_this$rtc$this$userIn19 = this.rtc[(_this$userInfo$status19 = this.userInfo.status) === null || _this$userInfo$status19 === void 0 ? void 0 : _this$userInfo$status19.externalOutputParty]) === null || _this$rtc$this$userIn19 === void 0 ? void 0 : _this$rtc$this$userIn19.subscribe(id, 'video', 'unExecuteCallback');
          }
        }
      } else if (this.shareList[id]) {
        // 其他初始化
      } else {
        if (this.State.audioType == 1) {
          _this.channels[id].hasUnsubscribe = true;
        } else {
          var _this$rtc$this$userIn20;
          (_this$rtc$this$userIn20 = _this.rtc[this.userInfo.realPartyList[0].realPartyCode]) === null || _this$rtc$this$userIn20 === void 0 ? void 0 : _this$rtc$this$userIn20.subscribe(id, 'video', 'unExecuteCallback');
          this.channels[id].hasUnsubscribe = false;
        }
      }
    },
    getPartyInfo(id, illegalPartyCode) {
      if (!id) return;
      const params = {};
      if (illegalPartyCode) {
        params._illegalPartyCode = illegalPartyCode;
      }
      this.axios.get(`/partyline-backend/party/${id}`, {
        params
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result;
          const {
            code,
            title,
            id,
            createTime
          } = result;
          this.State.currentPartyInfo = result;
          setTimeout(() => {
            Bus.$emit('changePartyAddress', {
              currentId: code,
              lastId: id,
              init: 'initAside',
              title,
              id,
              createTime
            });
          }, 500);
        }
      });
    },
    callbackByLiveSource({
      type,
      val,
      filter
    }) {
      if (type == 'getReceiverList' && !filter) {
        this.getReceiverList(true);
      } else if (type == 'getReceiverList' && filter) {
        this.cancel.getReceiverList();
        this.searchReceiverList(val);
      } else if (type == 'loadNextPage') {
        if (this.mainWindowInfo.hasNextPage) {
          this.sendOutputStream.pageNum++;
          this.getReceiverList('', '', 'load');
        }
      }
    },
    calculatePIpListWidth() {
      const screenWidth = document.getElementsByTagName('html')[0].offsetWidth;
      const screenHeight = document.getElementsByTagName('html')[0].offsetHeight;
      // 计算出一个盒子的宽度
      const oneVideoWidth = (screenWidth / this.State.currentPartyInfo.column).toFixed(4);
      const oneVideoHeight = (9 * oneVideoWidth / 16).toFixed(4);
      // 计算出可用的高度 = 文档高度 - 头部高度 - 中间 main window 高度 - 中间所有 padding 的和 - 底部栏高度
      const canUseHeight = screenHeight - 64 - 70 - 30 - 70;

      // 如果计算得出的行总高小于可用高则用全屏的宽度来显示视频
      if (oneVideoHeight * this.State.currentPartyInfo.layout <= canUseHeight && document.getElementsByClassName('videoBoxDiv')[0]) {
        document.getElementsByClassName('videoBoxDiv')[0].style.width = screenWidth + 'px';
      } else {
        // 总行高如果大于屏幕宽度，则用可用高来计算宽度
        const videoHeight = (canUseHeight / this.State.currentPartyInfo.layout).toFixed(4);
        const videoWidth = (16 * videoHeight / 9).toFixed(4);
        if (!document.getElementsByClassName('videoBoxDiv')[0]) return;
        document.getElementsByClassName('videoBoxDiv')[0].style.width = videoWidth * this.State.currentPartyInfo.column + 'px';
      }
    },
    controlInvite(val) {
      const params = {
        collaborateLogId: this.collaborateInfo.info.collaborateLogId,
        optionType: val ? 1 : 2
      };
      this.axios.post(`/partyline-backend/collaborate/noLogin/updateStatus?collaborateLogId=${params.collaborateLogId}&optionType=${params.optionType}`, params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          this.$message.success(this.$t('galleryHost.operationS'));
        } else if (res.data.errorCode == '82203101') {
          this.$message.warning(this.$t('common.invitedExpire'));
        }
      });
    },
    mainwindowSelectCallback(info) {
      const {
        type,
        val,
        nickName
      } = info;
      if (type === 'savePreviewName') {
        this.selectMainWindow = val;
      } else if (type === 'stopShare') {
        this.shareScreen('stopShare');
      } else if (type === 'stopBroadcaster') {
        this.cancelBroadcast();
      } else if (type === 'startBroadcaster') {
        this.attendCallback({
          type: 'setBroadcast',
          rtilCode: val,
          id: val,
          nickName
        });
      }
    },
    loadVideo(event, key) {
      if (this.buttonInfo.Status === 2 && event && event.currentTarget.className.includes('not-allowed')) return;
      if (key === 'last' && this.sendParmas.pageNum === 1) return;
      if (this.loadNextPageing) return;
      this.loadNextPageing = true;
      key === 'last' ? this.sendParmas.pageNum-- : this.sendParmas.pageNum++;
      if (key === 'next') {
        this.showLeft = true;
      } else if (key === 'last' && this.sendParmas.pageNum === 1) {
        this.showLeft = false;
      }
      this.channels = {};
      this.State.galleryChannels = [];
      this.joinPartyLine(key);
    },
    savePullRId(rid) {
      this.pullStreamObj.rid = rid;
      if (rid == this.groupInfo.pullStreamReceiverId) {
        this.pullStreamObj.text = 'Stop';
        this.pullStreamObj.status = 2;
      } else {
        this.pullStreamObj.text = 'Send';
        this.pullStreamObj.status = 1;
      }
    },
    getPullStreamList(val, key, condition) {
      if (!val) return;
      // 当时点击先拉框显示数据的时候默认加载第一页的数据
      if (!key || condition) {
        this.sendPullStream.pageNum = 1;
        this.sendPullStream.condition = condition;
      }
      this.axios.post('/partyline-backend/receiver/v2/page', this.sendPullStream).then(res => {
        if (res.data.errorCode === '0x0') {
          const {
            result
          } = res.data;
          this.pullStreamObj.info = result.cc;
          if (key) {
            this.pullStreamObj.rList = this.pullStreamObj.rList.concat(result.cc.list);
          } else {
            this.pullStreamObj.rList = result.cc.list;
          }
        }
      });
    },
    searchPullStreamList(condition) {
      if (this.searchPullStreamTimer) clearTimeout(this.searchPullStreamTimer);
      this.searchPullStreamTimer = setTimeout(() => {
        this.getPullStreamList(true, '', condition);
      }, 1000);
    },
    dealFootEvent(info) {
      const {
        type,
        val,
        shareType
      } = info;
      switch (type) {
        case 'muteVideo':
        case 'muteAudio':
          this.changeMeMute(val);
          break;
        case 'changeDevice':
          this.switchDevice(val);
          break;
        case 'changeMute':
          this.changeMute(val);
          break;
        case 'shareScreen':
          this.shareScreen(shareType);
          break;
        case 'showChat':
          this.State.showChatMessage = val;
          if (val) {
            this.showUnread = false;
            this.loadChatBox = true;
          }
          break;
      }
    },
    changeMeMute(val) {
      // 有私聊则在 realparty 里发流，没有私聊则在 external 里发流
      let operationResult = 'success';
      const type = val ? 'publish' : 'unpublish';
      Object.keys(this.rtc).forEach(async v => {
        if (val) {
          if (this.rtc[v]._localAudioTrack) {
            // 打开时需要判断当前自己是否有私聊
            if (this.State.privateInfo && this.State.privateInfo.crewRtilCode == this.userInfo.rtilCode) {
              if (this.State.privateInfo.realPartyCode === v) {
                operationResult = await controlDevicePublish(this.rtc[v], type, [this.rtc[v]._localAudioTrack]);
              }
            } else {
              operationResult = await controlDevicePublish(this.rtc[v], type, [this.rtc[v]._localAudioTrack]);
            }
          } else {
            if (this.State.privateInfo && this.State.privateInfo.crewRtilCode == this.userInfo.rtilCode) {
              if (this.State.privateInfo.realPartyCode === v) {
                controlAudio(this.rtc[v], this.devicesInfo, val, result => {
                  if (result == 'failed') operationResult = 'failed';
                });
              }
            } else {
              controlAudio(this.rtc[v], this.devicesInfo, val, result => {
                if (result == 'failed') operationResult = 'failed';
              });
            }
          }
        } else {
          if (!this.rtc[v]._localAudioTrack) return;
          operationResult = await controlDevicePublish(this.rtc[v], type, [this.rtc[v]._localAudioTrack]);
        }
      });
      if (operationResult === 'success') {
        controlDeviceBehavior({
          senderRtilCode: this.userInfo.rtilCode,
          type: 'mic',
          value: val,
          partyCode: this.userInfo.joinCode,
          toRtilCode: this.userInfo.rtilCode,
          origin: 'GalleryViewHost'
        });
      }
    },
    switchDevice(obj) {
      if (obj.type == 'speaker') {
        handleLocalStorage('set', 'speakerId', obj.deviceId);
        // mainWindow切换
        if (this.outputRtilCode) {
          this.$refs.mainwindowBox && this.$refs.mainwindowBox.setSpeakerAttendUser();
        }
        // 与会者切换
        this.$nextTick(() => {
          this.rtilCodeList.forEach(rtilCode => {
            if (this.$refs[`remoteSource${rtilCode}`] && rtilCode != this.outputRtilCode && this.$refs[`remoteSource${rtilCode}`][0]) {
              this.$refs[`remoteSource${rtilCode}`][0].setSpeakerAttendUser();
            }
          });
        });
      }
      if (obj === undefined) {
        this.State.guideObjShow = true;
      } else {
        Object.keys(this.rtc).forEach(key => {
          this.rtc[key] && this.rtc[key].setDevice(obj.deviceId, obj.type);
        });
      }
    },
    changeMute(flag) {
      if (!this.userInfo.rtilCode) return;
      // 更改状态
      this.$store.dispatch('isMute', !this.State.isMute);
      if (flag) {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOff')
        });
      } else {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOn')
        });
      }
      // 更新状态
      const params = [{
        mark: this.userInfo.rtilCode + '',
        annotation: this.groupPartyCode,
        key: 'speaker',
        value: !this.State.isMute
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params);
    },
    shareScreen(shareType) {
      //  先判断当前是否为自己停掉 shareScreen
      if (shareType === 'stopShare') {
        this.stopShare({
          id: this.shareRtilCode
        }, 'byClickShareIcon', 'userClick');
        return;
      }
      if (this.groupInfo.outputRid || this.State.galleryBroadcastInfo) {
        this.dailogInfo.show = true;
      } else {
        this.sendShareScreen();
      }
    },
    sendShareScreen() {
      this.dailogInfo.show = false;
      if (this.isShare) {
        this.$message.warning('You are in sharing screen');
        return;
      }
      const {
        externalOutput,
        externalOutputParty
      } = this.userInfo.status;
      const params = {
        memberId: `${this.userInfo.rtilCode}_shareScreen`,
        partyCode: externalOutput ? externalOutputParty : this.partyCodeList[0],
        role: 0,
        type: 3,
        host: true
      };
      this.axios.post('/partyline-backend/party/noLogin/shareScreen', params, {
        errorTip: false
      }).then(async res => {
        if (res.data.errorCode === '0x0') {
          const param = {
            ...res.data.result,
            partyCode: params.partyCode
          };
          const {
            appId,
            tokenCode,
            rtilCode,
            realPartyCode
          } = param;
          const temp = {
            appId,
            channel: realPartyCode + '',
            token: tokenCode,
            uid: rtilCode,
            share: true,
            subscribeRemote: false,
            status: this.State.partyJoinInfo.status
          };
          this.shareRtilCode = res.data.result.rtilCode;
          this.shareRtc = new AgoraClient(this.callBack);
          const uid = await this.shareRtc.join(temp); // 初始化视频流
          if (uid) {
            this.saveShareName(rtilCode);
            this.shareRtc.publish();
            this.isShare = true;
            this.sendPgm(rtilCode, 'ShareScreen');
            this.$set(this.State.localShareInfo, rtilCode, this.userInfo.rtilCode);
            this.$set(this.shareList, rtilCode, this.userInfo.rtilCode);
            handleLocalStorage('set', 'shareMemberId', params.memberId);
          }
        } else if (res.data.errorCode === '82201504') {
          routerJump('remove', {
            type: 'disableParty'
          });
        } else if (res.data.errorCode === '82201104') {
          this.$confirm(res.data.errorInfo, 'Operation failed', {
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {});
        } else {
          this.$message({
            type: 'error',
            message: res.data.errorInfo
          });
        }
      });
    },
    saveShareName(rtilCode) {
      if (!rtilCode || !this.userInfo.joinCode) return;
      const params = [{
        mark: String(rtilCode),
        annotation: this.userInfo.joinCode,
        key: 'nickName',
        notify: true,
        value: this.State.loginInfo.email + '_Screen_Share',
        initiator: String(rtilCode)
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {});
    },
    sendPgm(rtilCode, type) {
      const {
        externalOutput,
        externalOutputParty
      } = this.userInfo.status;
      const params = {
        partyCode: this.groupPartyCode,
        module: 'setOutput',
        msg: {
          rtilCode: rtilCode,
          pageNum: this.sendParmas.pageNum,
          outputInitiator: this.rtilCode,
          sourceType: type,
          externalOutput: externalOutput,
          externalOutputParty: externalOutputParty
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=84467', params);
    },
    showNamePopup() {
      this.nameInfo.show = true;
    },
    async setPartyOutput() {
      if (this.pullLoading) return;
      this.pullLoading = true;
      if (this.pullStreamObj.text === 'Send') {
        try {
          const {
            data: res
          } = await this.axios.get('/partyline-backend/receiver/getOutputInfo', {
            params: {
              rid: this.pullStreamObj.rid
            }
          });
          let livePeerName = '';
          if (res.result.livePeerName) {
            livePeerName = res.result.livePeerName;
          } else if (res.result.livePeerId) {
            livePeerName = res.result.livePeerId;
          }
          // status: 1 代表正在使用  status: 0 代表没在使用
          if (res.result.outputStatus) {
            const content = res.result.partyTitle || res.result.partyCode;
            this.tipsInfo.show = true;
            this.tipsInfo.title = 'partyInfo.switchOutput';
            this.tipsInfo.content = `<div class="end">${this.$t('pushParticipantSource.outputContent1')} <span style="color: #28282e;">${content}</span>, ${this.$t('pushParticipantSource.outputContent2')}</div>`;
          } else {
            // 如果在 live 在弹提示

            if (res.result.liveStatus) {
              this.tipsInfo.show = true;
              this.tipsInfo.title = 'pushParticipantSource.switchLive';
              this.tipsInfo.content = `<div class="end">${this.$t('pushParticipantSource.content1')} <span style="color: #28282e;">${livePeerName}</span>, ${this.$t('pushParticipantSource.content2')}</div>`;
            } else {
              this.startPullStream();
            }
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        this.stopPullStream();
      }
    },
    startPullStream() {
      if (!this.pullStreamObj.rid || !this.groupPartyCode) return;
      this.pullLoading = true;
      const params = {
        receiverId: this.pullStreamObj.rid,
        galleryCode: this.groupPartyCode,
        pageNum: this.sendParmas.pageNum
      };
      this.axios.post('/partyline-backend/group/startPullStream', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.pullStreamObj.status = 2;
          this.pullStreamObj.text = 'Stop';
          this.State.hadPullStream = true;
          this.groupInfo.pullStreamReceiverId = params.receiverId;
          this.$message.success(this.$t('galleryHost.operationS'));
        }
        this.pullLoading = false;
      });
    },
    stopPullStream() {
      if (!this.pullStreamObj.rid) return;
      this.pullLoading = true;
      const params = {
        receiverId: this.pullStreamObj.rid,
        galleryCode: this.groupPartyCode
      };
      this.axios.post('/partyline-backend/group/stopPullStream', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.pullStreamObj.status = 1;
          this.pullStreamObj.text = 'Send';
          this.State.hadPullStream = false;
          this.groupInfo.pullStreamReceiverId = '';
          this.$message.success(this.$t('galleryHost.stopOperationS'));
        }
        this.pullLoading = false;
      });
    },
    loadPullStreamList() {
      if (this.pullStreamObj.info.hasNextPage) {
        this.sendPullStream.pageNum++;
        this.getPullStreamList(true, 'load');
      }
    },
    searchReceiverList(condition) {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getReceiverList(true, condition);
      }, 500);
    },
    getReceiverList(init, condition, load) {
      if (init || condition) {
        this.sendOutputStream.pageNum = 1;
        this.sendOutputStream.condition = condition;
      }
      const _this = this;
      this.axios.post('/partyline-backend/receiver/v3/page', this.sendOutputStream, {
        cancelToken: new CancelToken(function executor(c) {
          _this.cancel.getReceiverList = c;
        })
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          var _result$cc$list;
          const array = [];
          const result = res.data.result;
          this.sourceIds = [];
          this.allRList = [];
          this.State.ppGalleryRlist = [];
          this.mainWindowInfo = result.cc;
          // receiver list
          const receiverObj = {};
          receiverObj.value = 'Receiver';
          receiverObj.label = 'Receiver';
          receiverObj.children = [];
          if ((_result$cc$list = result.cc.list) !== null && _result$cc$list !== void 0 && _result$cc$list.length) {
            var _result$cc$list2;
            if (init) {
              this.pullStreamObj.rList = result.cc.list;
            }
            if ((_result$cc$list2 = result.cc.list) !== null && _result$cc$list2 !== void 0 && _result$cc$list2.length) {
              result.cc.list.forEach(item => {
                this.sourceIds.push(item.peerId);
                const itemInfo = {
                  ...item,
                  value: item.peerId,
                  label: item.name
                };
                receiverObj.children.push(itemInfo);
              });
            } else {
              receiverObj.disabled = true;
            }
            array.push(receiverObj);
          }
          // pp list
          const ppObj = {};
          ppObj.value = 'Producer';
          ppObj.label = 'Producer';
          if (result.pps && result.pps.length) {
            ppObj.children = this.dealPPList(result.pps);
          } else {
            ppObj.disabled = true;
          }
          array.push(ppObj);
          this.allRList = array;
        }
      });
    },
    dealPPList(list) {
      const array = [];
      list.forEach(item => {
        item.pageInfo.list.forEach(info => {
          this.State.ppGalleryRlist.push(info);
          this.State.slotList.push(info.rids);
          const ppObj = {};
          ppObj.value = info.receiverId;
          ppObj.label = info.name;
          ppObj.userInfo = item.user;
          ppObj.children = info.rids.map((slotId, index) => {
            return {
              value: slotId,
              label: `Slot${index + 1}`
            };
          });
          array.push(ppObj);
        });
      });
      return array;
    },
    returnClass(status, key) {
      if (key === 'pullStream') {
        return this.pullStreamObj.rid ? this.State.buttonColor[status] : 'gray';
      } else {
        return this.value && this.value != 'None' ? this.State.buttonColor[status] : 'gray';
      }
    },
    returnColor(item, type) {
      let _str = '';
      if (type == 'pullStream') {
        if (item.peerId === this.groupInfo.pullStreamReceiverId) {
          _str = 'red';
        }
      } else {
        if (item.peerId === this.groupInfo.outputRid) {
          _str = 'red';
        }
      }
      return _str;
    },
    cancelBroadcast() {
      if (!this.State.galleryBroadcastInfo) return;
      const params = {
        partyCode: this.groupPartyCode,
        module: 'cancelOutput',
        msg: {
          rtilCode: this.State.galleryBroadcastInfo.rtilCode,
          sourceType: 'Participant'
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=87792', params);
    },
    cancelSpeaker() {
      const params = {
        partyCode: this.groupPartyCode,
        module: 'cancelSpeaker',
        msg: {
          rtilCode: this.State.gallerySpeakerInfo.rtilCode
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=45951', params);
    },
    setNameDefault() {
      this.nameCheck = this.nameInfo.checkVal;
    },
    setNameOperation() {
      const params = {
        partyCode: this.groupPartyCode,
        module: this.nameCheck ? 'showSlotText' : 'cancelShowSlotText',
        msg: {
          fontName: this.selectFontName
        },
        origin: 'Web_name'
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=74246', params).then(res => {
        const result = res.data;
        if (result.errorCode === '0x0') {
          this.nameInfo.show = false;
          this.nameInfo.checkVal = this.nameCheck;
        }
      });
    },
    async initJoinFn(newVal) {
      if (!newVal && (newVal + '').length != 16) return;
      this.groupId = this.currentPartyInfo.id;
      this.groupPartyCode = newVal;
      Bus.$emit('createWs', {
        ...this.State.config,
        partyCode: newVal
      });
      this.joinPartyLine();
    },
    async joinPartyLine(keepShare) {
      const partyCode = this.currentPartyInfo.code;
      this.$store.dispatch('checkEnv', {
        partyCode
      });
      const _this = this;
      for (const k in _this.rtc) {
        _this.rtc[k] && (await _this.rtc[k].leave());
        delete _this.rtc[k];
      }
      this.getAllMembers();
      // 获取状态
      this.bestOffset = 0;
      this.hasGetTimeOffset = false;
      this.partyCodeList = [];
      this.State.galleryPartyCodeList = [];
      await this.getPartyCodeList();
      // 如果进来默认有在send，直接显示send的视频
      if (JSON.stringify(this.groupInfo) != '{}' && this.groupInfo.outputRid) {
        this.buttonInfo.Text = 'Stop';
        this.buttonInfo.Status = 2;
        this.value = this.groupInfo.outputRid;
        this.selectRid = this.groupInfo.outputRid;
      } else {
        this.value = '';
        this.buttonInfo.Text = 'Send';
        this.buttonInfo.Status = 0;
        this.selectRid = '';
      }
      let memberId = handleLocalStorage('get', 'galleryMemberId');
      if (!memberId) {
        memberId = this.loginInfo.id + '_' + new Date().getTime();
        handleLocalStorage('set', 'galleryMemberId', memberId);
      }
      const params = {
        memberId: memberId,
        partyCode: this.groupPartyCode,
        role: 0,
        type: 0,
        groupId: this.groupPartyCode,
        host: true,
        behaviorKeyList: ['hearSelf', 'speaker', 'nickName', 'mic', 'camera', 'audioOnlyType', 'checkAudioMainWindow', 'flipVideo'],
        pageNum: this.sendParmas.pageNum
      };
      this.axios.post('/partyline-backend/party/noLogin/join', params).then(async res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          // 当party不是自己的时候，需要已参会者额身份加入
          if (!result.owner) {
            routerJump('participate', {
              join_id: result.joinCode
            });
            return;
          }
          addTabTitle({
            userInfo: result
          });
          this.State.partyJoinInfo = result;
          this.partyCodeList = result.realPartyList;
          result.status.volumeEffect === 0 ? this.audioLevel = true : this.audioLevel = false;
          const {
            externalJoinInfo,
            status,
            behavior,
            videoQualities
          } = result;
          // 传递GalleryView模式下的初始化数据
          Bus.$emit('initOperateData', status);
          if (result.anywhereGlobalSetting) {
            Bus.$emit('getAnyWhereGlobalSetting', {
              defaultView: result.anywhereGlobalSetting.defaultView && JSON.parse(result.anywhereGlobalSetting.defaultView).display,
              lockScreen: result.anywhereGlobalSetting.lockScreen && JSON.parse(result.anywhereGlobalSetting.lockScreen).lock,
              resolutionFps: result.anywhereGlobalSetting.resolutionFps && JSON.parse(result.anywhereGlobalSetting.resolutionFps),
              switchCamera: result.anywhereGlobalSetting.switchCamera && JSON.parse(result.anywhereGlobalSetting.switchCamera).position
            });
          }
          Bus.$emit('getCollaborateInfo');
          this.partyCodeList.forEach((item, index) => {
            var _this$State$privateIn3;
            const {
              rtilCode
            } = item;
            // 为了在gallery模式下记录userInfo
            Bus.$emit('saveUserInfo', res.data.result);
            // 用于向别的组件传递初始化数据
            this.freeTalk = false;
            if (result.layoutName == '2-2') {
              this.freeTalk = result.status.freeTalk;
            }
            Bus.$emit('updateInitStatus', {
              freeTalk: result.status.freeTalk
            });
            this.getUploadImageInfo(item.realPartyCode);
            // 默认显示耳机 默认设置host为crew
            this.State.crewInfo.rtilCode = rtilCode;
            this.State.currentRtilCode = rtilCode;
            this.State.joinInfo = res.data.result;
            this.userInfo = res.data.result;
            this.userInfo.appId = externalJoinInfo.externalPartyInfo[0].joinInfo.appId;
            this.rtilCode = rtilCode;
            this.State.isMute = behavior.speaker === 'false';
            this.State.audioType = behavior.audioOnlyType ? Number(behavior.audioOnlyType) : 0;
            this.State.checkMainWindow = behavior.checkAudioMainWindow !== 'false';
            Bus.$emit('changeAudioTypeVal');

            // 存储host 登录过的标记
            handleLocalStorage('set', 'isHost', result.owner);
            if (this.State.hadLoadPartyList) {
              this.State.newPageLoading = false;
            }
            this.$set(this.State.micStatus, this.userInfo.rtilCode, behavior.mic !== 'false');
            this.outputInitiator = status.outputInitiator;
            if (this.outputInitiator == this.userInfo.rtilCode && !keepShare) {
              // 取消分享
              this.cancelOutput();
              this.outputInitiator = '';
            }
            this.$set(this.behaviorInfo, rtilCode, behavior.nickName);
            // 自己是否在私聊
            if (status.privateConversation) {
              this.State.privateInfo = JSON.parse(status.privateConversation);
            } else {
              this.State.privateInfo = {};
            }
            // 是否存在别人在私聊
            if (!((_this$State$privateIn3 = this.State.privateInfoByOthers) !== null && _this$State$privateIn3 !== void 0 && _this$State$privateIn3.length)) {
              if (status.privateConversations) {
                this.State.privateInfoByOthers = JSON.parse(status.privateConversations);
              } else {
                this.State.privateInfoByOthers = [];
              }
            }
            const param = {
              ...item,
              videoQualities,
              memberId: params.memberId
            };
            this.slotIndex = status.galleryCopySlotIndex;
            this.outputRtilCode = status.output;
            this.State.outputCode = status.output;
            this.nameCheck = status.showSlotText;
            this.nameInfo.checkVal = status.showSlotText;
            this.State.groupLayout.layoutName = result.layoutName;
            this.State.groupLayout.layout = result.layoutName.split('-')[0];
            this.State.groupLayout.column = result.layoutName.split('-')[1];
            if (result.layoutName == '6-24-80-80') {
              this.showLeft = false;
              this.showNextPageIcon = false;
            }
            let videoFlag = false;
            if (status.outputId && (status.outputSource === 'Gallery' || status.outputSource === 'Default' || status.outputSource === 'SDI #2' || status.outputSource === 'SDI #1' || status.outputSource === 'VoIP')) {
              videoFlag = true;
              this.sourceType.params.receiverId = status.outputId;
              this.sourceType.currentRId = status.outputId;
              this.vfbVideoInfo = {
                rtilCode: status.output,
                id: status.output,
                nickName: status.nickName
              };
            }
            status.outputs.forEach(item => {
              if (item.outputSource === 'Participant') {
                this.broadcasterInfo = {
                  rtilCode: item.output,
                  id: item.output,
                  nickName: item.nickName
                };
                this.vfbVideoInfo = {
                  rtilCode: item.output,
                  id: item.output,
                  nickName: item.nickName
                };
                if (!videoFlag) {
                  this.selectMainWindow = 'Broadcaster';
                  this.value = 'Broadcaster';
                  this.buttonInfo.Status = 2;
                  this.buttonInfo.Text = 'Stop';
                  this.State.galleryBroadcastInfo = {
                    rtilCode: status.output,
                    id: status.output,
                    nickName: status.nickName
                  };
                }
              } else if (item.outputSource === 'PGM') {
                this.vfbVideoInfo = {
                  rtilCode: item.output,
                  id: item.output,
                  nickName: item.nickName
                };
              }
            });
            if (status.speaker) {
              this.vfbVideoInfo = {
                rtilCode: status.speaker,
                id: status.speaker,
                nickName: status.speakerNickName
              };
              this.State.gallerySpeakerInfo = {
                rtilCode: status.speaker,
                id: status.speaker,
                nickName: status.speakerNickName
              };
            }
            handleLocalStorage('set', 'manageRtilCode', res.data.result.managerRtils);
            // this.createdPartyLineRequest()
            this.getMeetingInfo(param, index, behavior, result);
            // 为了能让多host彼此能听见说话和所有与会者能听见host说话而加的
            if (this.partyCodeList.length == index + 1) {
              this.joinChatParty(externalJoinInfo, 'sendAudio', behavior);
            }
          });
        }
      });
    },
    async getMeetingInfo(param, index, behavior, result) {
      const {
        appId,
        tokenCode,
        rtilCode,
        realPartyCode,
        videoQualities
      } = param;
      // 为了发送 metadata 只能是 h264
      // const codec = this.State.groupLayout.layoutName === '2-4' ? 'h264' : 'vp8'
      // 如果当前自己存在私聊，则私聊在正常的party内需要推流, host 只需要在存在私聊的realParty里面发音频流
      const publish = this.State.privateInfo.crewRtilCode == this.userInfo.rtilCode && this.State.privateInfo.realPartyCode === realPartyCode;
      const mic = behavior.mic !== 'false';
      const params = {
        appId: appId,
        channel: realPartyCode + '',
        token: tokenCode,
        mode: 'live',
        codec: 'h264',
        uid: rtilCode,
        audioSource: true,
        isShowlocalStream: true,
        domId: `local_stream${realPartyCode}`,
        videoConfig: videoQualities,
        publishAudio: mic && publish,
        publishVideo: false,
        video: false,
        audio: !!this.devicesInfo.microphoneId && this.State.micStatus[this.userInfo.rtilCode],
        getRemoteNetworks: true,
        executeLocalSubscribe: true,
        startProxy: result.status.cloudProxy === 1
      };
      const _this = this;
      this.rtc[realPartyCode] = new AgoraClient(this.callBack);
      this.State.rtcList[realPartyCode] = this.rtc[realPartyCode];
      if (!handleLocalStorage('get', 'speakerId')) {
        handleLocalStorage('set', 'speakerId', this.devicesInfo.speakerId);
      }
      const uid = _this.rtc[realPartyCode] && (await _this.rtc[realPartyCode].join(params));
      this.loadNextPageing = false;
      if (uid) {
        var _this$userInfo$videoQ, _this$userInfo$videoQ2;
        this.hadOpenWebCloud = result.status.cloudProxy === 1;
        this.rtcLoaded = true;
        if (index == this.partyCodeList.length - 1) Bus.$emit('dealInitPrivateVideo', result, _this.rtc);
        /// 更改hostjr userId
        const userId = rtilCode + '_gallery_' + realPartyCode;
        window.hj && window.hj('identify', userId, {
          timeStamp: Date.now()
        });
        this.rtc[realPartyCode] && this.rtc[realPartyCode]._client.enableAudioVolumeIndicator();
        if (!this.hasGetTimeOffset) {
          const offset = await this.dealTimeOffset();
          this.bestOffset = offset;
          this.hasGetTimeOffset = true;
        }
        const fps = (_this$userInfo$videoQ = this.userInfo.videoQualities) === null || _this$userInfo$videoQ === void 0 ? void 0 : (_this$userInfo$videoQ2 = _this$userInfo$videoQ[0]) === null || _this$userInfo$videoQ2 === void 0 ? void 0 : _this$userInfo$videoQ2.fps;
        const intervalTime = fps ? Math.round(1000 / fps) : 33;
        if (this.sendMetadataTimer[realPartyCode]) clearInterval(this.sendMetadataTimer[realPartyCode]);
        this.sendMetadataTimer[realPartyCode] = setInterval(() => {
          this.sendMetadata(realPartyCode);
        }, intervalTime);
      }
    },
    async dealTimeOffset() {
      let bestRTT = Infinity;
      let bestOffset = 0;
      for (var i = 0; i < 10; i++) {
        const t0 = Date.now();
        const serverTime = await this.getTimeOffset();
        const t1 = Date.now();
        const rtt = t1 - t0;
        const offset = Date.now() - (serverTime + Math.round(rtt / 2));
        if (rtt < bestRTT) {
          bestRTT = rtt;
          bestOffset = offset;
        }
      }
      return bestOffset;
    },
    async getTimeOffset() {
      return await this.axios.get('/partyline-backend/base/getServerTime').then(res => {
        return res.data;
      });
    },
    sendMetadata(realPartyCode) {
      var _this$rtc$realPartyCo, _this$rtc$realPartyCo2;
      if (!((_this$rtc$realPartyCo = this.rtc[realPartyCode]) !== null && _this$rtc$realPartyCo !== void 0 && _this$rtc$realPartyCo.hasJoined)) return;
      const params = {
        offset: this.bestOffset,
        rtilCode: this.userInfo.rtilCode,
        timestamp: Date.now() + this.bestOffset
      };
      (_this$rtc$realPartyCo2 = this.rtc[realPartyCode]._client) === null || _this$rtc$realPartyCo2 === void 0 ? void 0 : _this$rtc$realPartyCo2.sendMetadata(new TextEncoder().encode(JSON.stringify(params)), function (error) {
        if (error) console.log('sendMetadata', error);
      });
    },
    joinChatParty(externalJoinInfo, key, behavior) {
      let memberId = handleLocalStorage('get', 'galleryMemberId');
      if (!memberId) {
        memberId = this.loginInfo.id + '_' + new Date().getTime();
        handleLocalStorage('set', 'galleryMemberId', memberId);
      }
      if (key === 'sendAudio') {
        this.chatParty = externalJoinInfo === null || externalJoinInfo === void 0 ? void 0 : externalJoinInfo.join;
      }
      externalJoinInfo && externalJoinInfo.externalPartyInfo.forEach(item => {
        if (key == 'sendAudio' || item.externalParty != this.chatParty) {
          this.getChatMeetingInfo(item.joinInfo, externalJoinInfo, key, behavior);
        }
      });
    },
    async getChatMeetingInfo(param, externalJoinInfo, key, behavior) {
      var _this$rtc$realPartyCo3;
      const {
        appId,
        tokenCode,
        rtilCode,
        realPartyCode,
        videoQualities
      } = param;
      // 如果当前自己存在私聊，则不在external推流，保证其他host听不见声音
      const publish = this.State.privateInfo.crewRtilCode && this.State.privateInfo.crewRtilCode != this.userInfo.rtilCode;
      const params = {
        appId: appId,
        channel: realPartyCode + '',
        token: tokenCode,
        mode: 'live',
        codec: 'h264',
        uid: rtilCode,
        audioSource: true,
        isShowlocalStream: true,
        domId: key === 'sendAudio' ? 'sendVideo' : '',
        videoConfig: videoQualities,
        video: false,
        audio: !!this.devicesInfo.microphoneId && this.State.micStatus[this.userInfo.rtilCode],
        executeLocalSubscribe: true,
        executeVideoAdded: true,
        publishAudio: behavior.mic === 'true' && publish
      };
      // id更换channel
      this.rtc[realPartyCode] = new AgoraClient(this.callBack);
      this.State.rtcList[realPartyCode] = this.rtc[realPartyCode];
      const uid = await ((_this$rtc$realPartyCo3 = this.rtc[realPartyCode]) === null || _this$rtc$realPartyCo3 === void 0 ? void 0 : _this$rtc$realPartyCo3.join(params));
      if (uid) {
        this.rtcLoaded = true;
        if (key === 'sendAudio') this.joinChatParty(externalJoinInfo, 'receiverAudio');
      }
    },
    getAllMembers() {
      if (!this.currentPartyInfo.code) return;
      this.axios.get(`/partyline-backend/party/noLogin/onlineMembers/${this.currentPartyInfo.code}`).then(res => {
        if (!res) return;
        if (res.data.errorCode == '0x0') {
          const number = res.data.result;
          this.allPartyMembers = [];
          Object.keys(number).forEach(v => {
            const rtilCodes = number[v].map(val => {
              const type = this.State.deviceTypeMap[val.rtilCode];
              if (type != 'T' && type != 'R' && type != 'Anywhere' && type != 'App') return val.rtilCode;
            });
            this.allPartyMembers = this.allPartyMembers.concat(rtilCodes);
          });
          this.allPartyMembers.unshift(this.userInfo.rtilCode);
        }
      });
    },
    chatCallback({
      type,
      rtilCode,
      data
    }) {
      if (type == 'nickName') {
        this.getNickName(rtilCode);
      }
      if (type == 'getAllMembers') {
        this.getAllMembers();
      }
      if (type == 'unreadInfo') {
        let showUnread = false;
        Bus.$emit('chatUnread', false);
        Object.keys(data).forEach(keys => {
          if (data[keys].unRead) {
            showUnread = true;
            Bus.$emit('chatUnread', showUnread);
            this.showUnread = showUnread;
          }
        });
      }
    },
    async getPartyCodeList() {
      return new Promise((resolve, reject) => {
        this.sendParmas.groupId = this.groupPartyCode;
        if (!this.groupPartyCode) return;
        this.axios.post('/partyline-backend/group/noLogin/v3/status', this.sendParmas).then(res => {
          if (res.data.errorCode === '0x0') {
            const result = res.data.result;
            this.groupInfo = result;
            this.State.groupInfo = result;
            this.State.galleryAllGroupRtilCodes = result.groupRtilCodes;
            this.rtilCodeList = result.groupRtilCodes;
            this.State.galleryPartyCodeList = result.partyCodeList;
            this.pullStreamObj.rid = result.pullStreamReceiverId;
            // 为了 Gallery view 新功能显示 last frame 添加
            const partyCodeWithRtilCodesPosition = result.partyCodeWithRtilCodesPosition;
            partyCodeWithRtilCodesPosition && partyCodeWithRtilCodesPosition.forEach(item => {
              const partyCode = item.partyCode;
              const rtilCodesList = item.rtilCodes;
              rtilCodesList.forEach(rtilCode => {
                if (rtilCode > 0) {
                  this.$set(this.channels, rtilCode, {
                    channel: partyCode,
                    id: rtilCode,
                    leave: true
                  });
                }
              });
            });
            if (result.pullStreamReceiverId) {
              this.pullStreamObj.status = 2;
              this.pullStreamObj.text = 'Stop';
              this.State.hadPullStream = true;
            } else {
              this.pullStreamObj.status = 1;
              this.pullStreamObj.text = 'Start';
            }
            resolve();
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
    createdPartyLineRequest() {
      if (this.PartyLineRequest) return;
      const taskId = Tool.return32Str();
      if (!this.Config.urlInfo) return;
      const url = `wss://${this.Config.urlInfo.ccWebsocket}/partyLineRequest?taskId=${taskId}&partyCode=${-1}&rtilCode=${this.rtilCode}&groupId=${this.groupPartyCode}&isHost=true`;
      this.PartyLineRequest = Tool.createWs(url);
      this.updateStatusTimer = setInterval(() => {
        if (this.PartyLineRequest && this.PartyLineRequest.client.readyState === 1) {
          this.PartyLineRequest.send(3); // partyline心跳
        }
      }, 5000);
    },
    updateSourceData(obj) {
      this.sourceType.type = obj.source;
      this.selectRid = obj.currentRId;
      this.sourceType.startType = obj.type;
      if (obj.operateType === 'stop') {
        this.stopReceiverParty();
      } else {
        if (obj.type) {
          if (this.shareRtilCode != '') {
            this.$message({
              type: 'warning',
              message: 'Please stop share screen first.'
            });
            return;
          }
          if (this.State.galleryBroadcastInfo) {
            this.$confirm(this.$t('commonFunction.broadcasterSource'), {
              confirmButtonText: this.$t('commonFunction.switch'),
              cancelButtonText: this.$t('commonFunction.cancel'),
              customClass: 'confirmBox',
              cancelButtonClass: 'cancelBtn',
              confirmButtonClass: 'joinBtn',
              center: false
            }).then(() => {
              this.StartReceiverParty(obj);
            });
          } else {
            this.StartReceiverParty(obj);
          }
        }
      }
    },
    StartReceiverParty(obj) {
      if (!this.selectRid || !this.sendParmas.groupId) return;
      if (this.outputInitiator && this.outputInitiator != this.userInfo.rtilCode && obj.type != 'SDIOut') {
        this.$message({
          type: 'warning',
          message: this.$t('remainWords.anotherSharing')
        });
        return;
      }
      const parmas = {
        receiverId: this.selectRid,
        galleryCode: this.sendParmas.groupId,
        source: this.sourceType.type,
        trackIds: obj.trackIds
      };
      if (this.liveLoading) return;
      this.liveLoading = true;
      this.axios.post('/partyline-backend/group/startPushStream', parmas, {
        errorTip: false
      }).then(res => {
        this.liveLoading = false;
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('galleryHost.sendSucc'));
          obj.callback && obj.callback(obj);
          this.buttonInfo.Text = 'Stop';
          this.buttonInfo.Status = 2;
          if (obj.output) {
            this.groupInfo.outputType = this.sourceType.type;
          }
          this.groupInfo.outputRid = this.selectRid;
          if (!obj.output || this.sourceType.type == 'group') this.groupInfo.galleryMode = true;
        } else if (res.data.errorCode == '82201204') {
          const result = JSON.parse(res.data.errorInfo);
          const array = [];
          result.encoders.forEach(item => {
            const obj = {};
            obj.code = item.code;
            obj.title = item.title ? item.title : new Date(item.createTime).toLocaleDateString() + ' ' + new Date(item.createTime).toLocaleTimeString();
            obj.mode = this.ChannelMode[item.mode] ? this.ChannelMode[item.mode].toLowerCase() : '';
            obj.email = item.loginUser.email;
            array.push(obj);
          });
          this.encoderInfo.maxNumber = result.maxEncoderNumber;
          this.encoderInfo.data = array;
          this.encoderInfo.visible = true;
        } else {
          this.$message({
            type: 'error',
            message: this.$t('galleryHost.sendFailed')
          });
        }
      }).catch(() => {
        this.liveLoading = false;
      });
    },
    stopReceiverParty(obj) {
      const parmas = {
        receiverId: obj ? obj.currentRId : this.selectRid,
        galleryCode: this.sendParmas.groupId
      };
      if (this.liveLoading) return;
      this.liveLoading = true;
      this.axios.post('/partyline-backend/group/stopPushStream', parmas).then(res => {
        this.liveLoading = false;
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('galleryHost.stopSucc'));
          obj && obj.callback && obj.callback(obj);
          if (obj && obj.operateType == 'stop' && obj.type == 'SDIOut') {
            if (this.groupInfo.outputType == 'group') this.groupInfo.outputType = '';
          } else {
            this.groupInfo.outputType = '';
          }
          this.buttonInfo.Text = 'Send';
          this.buttonInfo.Status = 1;
          this.selectRid = '';
          this.sourceType.type = '';
          this.groupInfo.outputRid = '';
        }
      }).catch(() => {
        this.liveLoading = false;
      });
    },
    async callBack({
      action,
      payload
    }) {
      var _this$rtc$this$userIn21, _this$userInfo$realPa, _this$userInfo$realPa2, _changeDevice$device, _this$userInfo$realPa3, _changeDevice$device2, _this$rtc$this$userIn22, _changeDevice$device3, _this$rtc$this$userIn23, _this$devicesInfo$mic, _this$userInfo$realPa4;
      const {
        id,
        changeDevice,
        shareInfo
      } = payload;
      switch (action) {
        case 'unlinkQuality':
          this.unlinkQuality(payload);
          break;
        case 'user-joined':
          this.userJoin(payload);
          break;
        case 'user-left':
          this.userLeave(payload);
          break;
        case 'subscribe-track':
          this.subscribeTrack(payload);
          break;
        case 'subscribe-video':
          this.dealSubscribeVideo(payload);
          break;
        case 'user-published':
        case 'user-unpublished':
          this.muteAudioOrVideo(action, payload);
          break;
        case 'start-share':
          const obj = {
            id,
            videoTrack: shareInfo.videoTrack,
            audioTrack: shareInfo.audioTrack
          };
          this.vfbVideoInfo = obj;
          break;
        case 'stop-share':
          this.stopShare(payload, false, 'agoraStopShareCallback');
          break;
        case 'local-track':
          const {
            videoTrack,
            audioTrack
          } = payload;
          if (!this.meInfo.id) this.$set(this.meInfo, 'id', this.userInfo.rtilCode);
          videoTrack && this.$set(this.meInfo, 'videoTrack', videoTrack);
          audioTrack && this.$set(this.meInfo, 'audioTrack', audioTrack);
          if ((_this$rtc$this$userIn21 = this.rtc[this.userInfo.realPartyList[0].realPartyCode]) !== null && _this$rtc$this$userIn21 !== void 0 && _this$rtc$this$userIn21._localAudioTrack) {
            const mediaStream = this.rtc[this.userInfo.realPartyList[0].realPartyCode]._localAudioTrack._mediaStreamTrack;
            this.showMicMutedInfo.show = mediaStream.muted;
            mediaStream.onmute = () => {
              this.showMicMutedInfo.show = true;
            };
            mediaStream.onunmute = () => {
              this.showMicMutedInfo.show = false;
            };
          }
          break;
        case 'local-publish':
          if (payload.type.includes('audio')) {
            this.$set(this.State.micStatus, this.userInfo.rtilCode, true);
          }
          break;
        case 'local-unpublish':
          if (payload.type.includes('audio')) {
            this.$set(this.State.micStatus, this.userInfo.rtilCode, false);
          }
          break;
        case 'connection-state-change':
          // 代表有人重复加入
          if (payload.reason === 'UID_BANNED') {
            this.repeatInfo.show = true;
          }
          break;
        case 'cameraChange':
          if (!this.rtc || !this.rtc[(_this$userInfo$realPa = this.userInfo.realPartyList) === null || _this$userInfo$realPa === void 0 ? void 0 : (_this$userInfo$realPa2 = _this$userInfo$realPa[0]) === null || _this$userInfo$realPa2 === void 0 ? void 0 : _this$userInfo$realPa2.realPartyCode]) return;
          this.devicesInfo = await this.rtc[this.userInfo.realPartyList[0].realPartyCode].getDevice();
          if (this.rtc[this.userInfo.realPartyList[0].realPartyCode]._localVideoTrack && ((_changeDevice$device = changeDevice.device) === null || _changeDevice$device === void 0 ? void 0 : _changeDevice$device.label) === this.rtc[this.userInfo.realPartyList[0].realPartyCode]._localVideoTrack.getTrackLabel()) {
            const oldCameras = await this.rtc[this.userInfo.realPartyList[0].realPartyCode]._AgoraRTC.getCameras();
            oldCameras[0] && this.rtc[this.userInfo.realPartyList[0].realPartyCode].setDevice(oldCameras[0].deviceId, 'video', type => {
              type === 'success' ? this.$message.success(this.$t('common.autoSwitchNewCameraSuccess')) : this.$message.error(this.$t('common.autoSwitchNewCameraFailed'));
              this.devicesInfo.cameraId = oldCameras[0].deviceId;
            });
          }
          break;
        case 'micChange':
          const _this = this;
          if (!this.rtc || !this.rtc[(_this$userInfo$realPa3 = this.userInfo.realPartyList) === null || _this$userInfo$realPa3 === void 0 ? void 0 : _this$userInfo$realPa3[0].realPartyCode]) return;
          this.devicesInfo = await this.rtc[_this.userInfo.realPartyList[0].realPartyCode].getDevice();
          if (this.rtc[this.userInfo.realPartyList[0].realPartyCode]._localAudioTrack && (this.rtc[this.userInfo.realPartyList[0].realPartyCode]._localAudioTrack._deviceName.includes((_changeDevice$device2 = changeDevice.device) === null || _changeDevice$device2 === void 0 ? void 0 : _changeDevice$device2.label) || changeDevice.state === 'INACTIVE' && ((_this$rtc$this$userIn22 = this.rtc[this.userInfo.realPartyList[0].realPartyCode]._localAudioTrack) === null || _this$rtc$this$userIn22 === void 0 ? void 0 : _this$rtc$this$userIn22._config.microphoneId) == 'default')) {
            const oldMic = await this.rtc[this.userInfo.realPartyList[0].realPartyCode]._AgoraRTC.getMicrophones();
            if (!oldMic || oldMic.length === 0) return;
            Object.keys(this.rtc).forEach(key => {
              this.rtc[key] && this.rtc[key].setDevice(oldMic[0].deviceId, 'audio', type => {
                if (type == 'success' && key == this.userInfo.realPartyList[0].realPartyCode) {
                  this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
                } else if (type != 'success') {
                  this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
                }
                this.devicesInfo.microphoneId = oldMic[0].deviceId;
              });
            });
          } else if (changeDevice.state === 'ACTIVE' && this.rtc[this.userInfo.realPartyList[0].realPartyCode]._localAudioTrack && !this.rtc[this.userInfo.realPartyList[0].realPartyCode]._localAudioTrack._deviceName.includes((_changeDevice$device3 = changeDevice.device) === null || _changeDevice$device3 === void 0 ? void 0 : _changeDevice$device3.label) && ((_this$rtc$this$userIn23 = this.rtc[this.userInfo.realPartyList[0].realPartyCode]._localAudioTrack) === null || _this$rtc$this$userIn23 === void 0 ? void 0 : _this$rtc$this$userIn23._config.microphoneId) != 'default' && ((_this$devicesInfo$mic = this.devicesInfo.microphoneList[0]) === null || _this$devicesInfo$mic === void 0 ? void 0 : _this$devicesInfo$mic.label) != this.rtc[this.userInfo.realPartyList[0].realPartyCode]._localAudioTrack._deviceName) {
            // 插入mic
            Object.keys(this.rtc).forEach(key => {
              this.rtc[key] && this.rtc[key].setDevice(changeDevice.device.deviceId, 'audio', type => {
                if (type == 'success' && key == this.userInfo.realPartyList[0].realPartyCode) {
                  this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
                } else if (type != 'success') {
                  this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
                }
              });
            });
          }
          break;
        case 'playbackChange':
          const rtc = this.rtc[(_this$userInfo$realPa4 = this.userInfo.realPartyList) === null || _this$userInfo$realPa4 === void 0 ? void 0 : _this$userInfo$realPa4[0].realPartyCode];
          if (!rtc) return;
          if (typeof HTMLAudioElement.prototype.setSinkId === 'undefined') {
            this.$t('common.notSupportSwitchSpeaker');
            return;
          }
          if (changeDevice.state !== 'ACTIVE' && rtc._localAudioTrack) {
            const currentDeviceId = handleLocalStorage('get', 'speakerId');
            const currentLabelArray = this.devicesInfo.speakerList.filter(item => item.deviceId == currentDeviceId);
            const currentSpeakerList = await rtc._AgoraRTC.getPlaybackDevices();
            const haveUseDevice = currentSpeakerList.find(item => item.label == currentLabelArray[0].label);
            if (!haveUseDevice) {
              handleLocalStorage('set', 'speakerId', currentSpeakerList[0].deviceId);
              const array = Object.keys(this.channels).filter(rtilCode => {
                return rtilCode != this.userInfo.rtilCode;
              });
              array.forEach(rtilCode => {
                if (this.channels[rtilCode].audioTrack) {
                  var _this$channels$rtilCo6, _this$channels$rtilCo7;
                  (_this$channels$rtilCo6 = (_this$channels$rtilCo7 = this.channels[rtilCode].audioTrack).setPlaybackDevice) === null || _this$channels$rtilCo6 === void 0 ? void 0 : _this$channels$rtilCo6.call(_this$channels$rtilCo7, currentSpeakerList[0].deviceId);
                }
              });
            }
          }
          this.devicesInfo = await rtc.getDevice();
          break;
      }
    },
    userJoin(payload) {
      const {
        id
      } = payload;
      if (!id) return;
      this.getNickName(id);
      if (this.channels[id]) {
        this.channels[id].leave = false;
      }
      if (!this.channels[id]) {
        this.$set(this.channels, id, {
          id: id
        });
      }
      this.axios.post(`/partyline-backend/member/noLogin/queryByRtilCode/${id}`).then(res => {
        if (!res) return;
        if (res.data.errorCode == '0x0') {
          const obj = Object.assign({}, this.channels[id]);
          const result = res.data.result;
          const type = returnSourceType(result);
          this.$set(this.rtilCodeKeyTypeVal, id, type);
          this.$set(this.State.deviceTypeMap, id, type);
          // anywhereSetting设置
          if (result.deviceType === 'T' && result.devicePlatform <= 14 && result.devicePlatform >= 10) {
            this.$set(this.anyWherePlatForms, id, result.devicePlatform);
            this.$set(this.anyWherePeerIds, id, result.devicePeerId);
          }
          if (type == 'App') {
            var _result$accountId;
            this.$set(this.anyWherePeerIds, payload.id, (_result$accountId = result.accountId) === null || _result$accountId === void 0 ? void 0 : _result$accountId.split('_')[1]);
          }
          const accountId = result.accountId.toLowerCase();
          const _this = this;
          if (payload.channel == _this.userInfo.realPartyCode) {
            this.$set(this.channels, id, {
              ...payload,
              ...obj,
              tid: res.data.result.accountId
            });
            this.channels[id] && this.$set(this.channels[id], 'info', result);
          } else {
            this.$set(this.State.galleryExternalChannels, id, {
              ...payload,
              ...obj,
              tid: res.data.result.accountId
            });
            this.channels[id] && this.$set(this.channels[id], 'info', result);
          }
          let shareInitiator = '';
          let shareCode = '';
          if (accountId.indexOf('_sharescreen') > -1) {
            shareCode = id;
            shareInitiator = accountId.split('_sharescreen')[0];
            this.$set(this.shareList, shareCode, shareInitiator);
          }
          // 为了live时，找出rtilcode与account的一一对应关系
          this.allAccountIdByRtilCode[id] = res.data.result.accountId.toLowerCase();
        }
      });
    },
    // 用于显示与会者网络质量
    unlinkQuality(payload) {
      if (!payload.type) return;
      this.$set(this.remoteNetWorks, payload.id, {
        uplinkNetworkQuality: payload.uplinkNetworkQuality,
        downlinkNetworkQuality: payload.downlinkNetworkQuality
      });
    },
    getNickName(id, anywhereSetting) {
      if (!this.groupPartyCode) return;
      this.axios.post('/partyline-backend/behavior/noLogin/getList', {
        originRtilCode: this.userInfo.rtilCode,
        annotation: this.groupPartyCode,
        keys: ['nickName', 'tagName', 'camera', 'mic', 'flipVideo', 'resolution', 'fps', 'resolutionOptions', 'fpsOptions', 'whiteBalance', 'whiteBalanceRange', 'cameraOptions', 'whiteBalancePredefined', 'lock', 'whiteBalanceAuto', 'cameraPosition', 'defaultView', 'autoFocus', 'focusDistance', 'focusDistanceRange', 'autoExposure', 'exposure', 'exposureRange', 'zoom', 'zoomRange', 'isSupportGimbal', 'speakerVolume', 'speakerStatus', 'gimbalAngleValue', 'gimbalAngleRange', 'audioDeviceList', 'audioDeviceID', 'videoDeviceList', 'videoDeviceID', 'resolutionList', 'fpsList'],
        marks: [id]
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result[id];
          this.$set(this.degreeHost, id, result.flipVideo);
          this.$set(this.behaviorInfo, id, result.nickName);
          this.$set(this.tagNameInfo, id, result.tagName);
          // this.$set(this.State.micStatus, id, result.mic && result.mic !== 'false')
          // this.$set(this.State.cameraStatus, id, result.camera && result.camera !== 'false')
          this.$set(this.anyWhereSettings, id, {
            fps: result.fps,
            resolution: result.resolution,
            whiteBalance: result.whiteBalance ? JSON.parse(result.whiteBalance) : {},
            lock: result.lock,
            whiteBalanceAuto: result.whiteBalanceAuto,
            cameraPosition: result.cameraPosition,
            resolutionOptions: result.resolutionOptions,
            fpsOptions: result.fpsOptions,
            whiteBalanceRange: result.whiteBalanceRange,
            cameraOptions: result.cameraOptions,
            whiteBalancePredefined: result.whiteBalancePredefined,
            defaultView: result.defaultView,
            autoFocus: result.autoFocus,
            focusDistanceRange: result.focusDistanceRange,
            focusDistance: result.focusDistance ? result.focusDistance : 0,
            autoExposure: result.autoExposure,
            exposureRange: result.exposureRange,
            exposure: result.exposure ? result.exposure : 0,
            zoom: result.zoom ? result.zoom : 0,
            zoomRange: result.zoomRange,
            isSupportGimbal: result.isSupportGimbal,
            speakerVolume: result.speakerVolume ? result.speakerVolume : 100,
            speakerStatus: result.speakerStatus,
            gimbalAngleValue: result.gimbalAngleValue,
            gimbalAngleRange: result.gimbalAngleRange,
            audioDeviceList: result.audioDeviceList,
            audioDeviceID: result.audioDeviceID,
            videoDeviceList: result.videoDeviceList,
            videoDeviceID: result.videoDeviceID,
            resolutionList: result.resolutionList,
            fpsList: result.fpsList
          });
          if (anywhereSetting) {
            this.anyWhereInfo.show = true;
          }
        }
      });
    },
    userLeave(payload) {
      const {
        id,
        channel
      } = payload;
      // 更新所有可以moveParty的rtilCode
      this.State.batchMoveParticipateList = this.State.batchMoveParticipateList.filter(v => v != payload.id);
      this.$set(this.movePips, id, false);
      if (this.State.localShareInfo[id]) this.$delete(this.State.localShareInfo, id);
      this.$delete(this.State.deviceTypeMap, id);
      if (this.channels[id] && this.channels[id].channel == channel) {
        // this.$delete(this.channels, id)
        this.$set(this.channels[id], 'leave', true);
        this.State.galleryChannels = this.channels;
      }
      this.batchMovePartyInfo.rtilCodes = this.batchMovePartyInfo.rtilCodes.filter(v => v != id);
      // 如果当前弹窗开着需要关闭
      if (id == this.anyWhereInfo.rtilCode) {
        this.anyWhereInfo.show = false;
        this.$set(this.anywhereSettingShowMap, this.anyWhereInfo.rtilCode, false);
        this.anyWhereInfo.rtilCode = '';
        this.vfbVideoInfo = null;
        this.$message.success(this.$t('anywhereSetting.userLeft'));
      }
    },
    subscribeTrack(payload) {
      var _this$rtc$channel;
      const {
        id,
        videoTrack,
        audioTrack,
        channel
      } = payload;
      if (this.State.localShareInfo[id]) return;
      (_this$rtc$channel = this.rtc[channel]) === null || _this$rtc$channel === void 0 ? void 0 : _this$rtc$channel._client.setRemoteVideoStreamType(id, this.State.groupLayout.layout >= 6 ? 1 : 0);
      const _this = this;
      if (channel == this.chatParty) {
        if (_this.vfbVideoInfo && _this.vfbVideoInfo.id == id) {
          const obj = {};
          obj.id = id;
          obj.videoTrack = videoTrack;
          obj.audioTrack = audioTrack;
          obj.channel = channel;
          obj.hasUnsubscribe = this.vfbVideoInfo.hasUnsubscribe;
          // 设置speaker的时候不需要显示视频
          if (this.State.gallerySpeakerInfo && this.State.gallerySpeakerInfo.rtilCode == id) {
            this.vfbVideoInfo = null;
          } else {
            this.vfbVideoInfo = obj;
          }
          this.$set(this.State.galleryExternalChannels, id, obj);
          if (this.State.gallerySpeakerInfo && this.State.gallerySpeakerInfo.rtilCode == id) {
            this.rtcByRtilCode[id] = this.rtc[channel];
          }
        }
      } else {
        var _this$channels$id;
        // 列表流的显示
        const obj = Object.assign({}, this.channels[id]);
        obj.id = id;
        obj.channel = channel;
        obj.videoTrack = videoTrack;
        obj.audioTrack = audioTrack;
        obj.info = (_this$channels$id = this.channels[id]) === null || _this$channels$id === void 0 ? void 0 : _this$channels$id.info;
        this.$set(this.channels, id, obj);
        if (this.anyWhereInfo.show && id == this.anyWhereInfo.rtilCode) {
          if (this.rtc[channel]._subscribeTrack[id]) {
            const obj = {};
            obj.id = id;
            obj.channel = channel;
            obj.videoTrack = this.rtc[channel]._subscribeTrack[id].videoTrack;
            obj.audioTrack = this.rtc[channel]._subscribeTrack[id].audioTrack;
            this.vfbVideoInfo = obj;
          }
        }
        this.rtcByRtilCode[id] = this.rtc[channel];
      }
      this.State.galleryChannels = this.channels;
      // 当头部的public speaker Agora 的流推送慢于ws推送·
      if (this.State.gallerySpeakerInfo && (this.State.gallerySpeakerInfo.rtilCode == payload.id || this.State.gallerySpeakerInfo.id == id)) {
        var _this$channels$id2;
        const obj = {};
        obj.id = id;
        obj.videoTrack = videoTrack;
        obj.audioTrack = audioTrack;
        obj.channel = channel;
        obj.info = (_this$channels$id2 = this.channels[id]) === null || _this$channels$id2 === void 0 ? void 0 : _this$channels$id2.info;
        this.State.gallerySpeakerInfo = Object.assign(this.State.gallerySpeakerInfo, obj);
        // 根据第N次需求改动，speaker的流要显示到原来的位置上
        this.$set(this.channels, id, obj);
      }
    },
    muteAudioOrVideo(action, payload) {
      const {
        id,
        mediaType
      } = payload;
      const val = action === 'user-published';
      mediaType === 'video' ? this.$set(this.State.cameraStatus, id, val) : this.$set(this.State.micStatus, id, val);
    },
    stopShare(payload, byClickShareIcon, type) {
      this.cancalShareCommand(payload.id, type);
      if (byClickShareIcon) {
        this.cancelStopShare();
      }
      this.$delete(this.shareList, payload.id);
    },
    cancelStopShare() {
      if (this.shareRtc && this.shareRtc._shareTrack) {
        var _this$shareRtc$_share;
        (_this$shareRtc$_share = this.shareRtc._shareTrack._mediaStreamTrack) === null || _this$shareRtc$_share === void 0 ? void 0 : _this$shareRtc$_share.stop();
        this.shareRtc.leave();
      }
    },
    cancalShareCommand(id, type) {
      const params = {
        partyCode: this.groupPartyCode,
        module: 'cancelShareScreen',
        origin: 'commonPartyHost',
        msg: {
          rtilCode: id,
          stopType: type
        }
      };
      if (!id) return;
      this.axios.post('/partyline-backend/party/noLogin/command?key=85389', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.isShare = false;
          this.hasShare = false;
          this.cancelOutput();
        }
      });
    },
    keydownEvent(ev) {
      if (ev.keyCode == 27) {
        if (this.pipsListFullScreen) {
          this.pipsListFullScreen = false;
        }
      }
    },
    layoutClass(rtilCode, index) {
      let _str = '';
      if (this.State.groupLayout.layout) _str = `layout-${this.State.groupLayout.layoutName}`;
      // 根据最新需求大于72的时候都改成一面显示72个
      if (this.State.groupLayout.layout * this.State.groupLayout.column > 72) {
        _str = _str + ' ' + 'video72';
      }
      if (this.State.groupLayout.layoutName === '6-24-80-80') {
        if (this.videoIndex) {
          if (index < 72) {
            _str = _str + ' ' + 'notWidth';
          }
        } else {
          if (index > 71) {
            _str = _str + ' ' + 'notWidth';
          }
        }
      }
      return _str;
    },
    returnRoleList(rtilCode) {
      // this.State.groupLayout.layoutName == '2-2' ||
      if (this.freeTalk || this.operateList[rtilCode] && this.operateList[rtilCode].includes('cancelPrivateConversation')) {
        return [];
      }
      let roleList = ['participant'];
      // 如果有speaker则根据speaker rtilCode去判断要怎么显示
      if ((!this.State.gallerySpeakerInfo || this.State.gallerySpeakerInfo && this.State.gallerySpeakerInfo.rtilCode == rtilCode) && !this.State.galleryBroadcastInfo) roleList.unshift('setPublicSpeaker');
      // 如果有broadcaster，或者当前是public speaker则不返回这个
      if ((!this.State.galleryBroadcastInfo || this.State.galleryBroadcastInfo && this.State.galleryBroadcastInfo.rtilCode == rtilCode) && !this.State.gallerySpeakerInfo) {
        roleList.unshift('setBroadcast');
      }
      if (this.rtilCodeKeyTypeVal[rtilCode] != 'Web') {
        roleList = [];
      }
      return roleList;
    },
    returnRole(rtilCode) {
      let role = 'participant';
      if (this.State.gallerySpeakerInfo && this.State.gallerySpeakerInfo.rtilCode == rtilCode) role = 'setPublicSpeaker';
      if (this.State.galleryBroadcastInfo && this.State.galleryBroadcastInfo.rtilCode == rtilCode) role = 'setBroadcast';
      return role;
    },
    attendCallback(obj) {
      let {
        type,
        id,
        val,
        partyCode,
        index
      } = obj;
      if (type == 'editTagName') {
        this.editTagName(obj);
      }
      if (type == 'removePepole') {
        this.hasRemovePeople(obj);
      }
      if (type == 'replace') {
        if (this.State.gallerySpeakerInfo && this.State.gallerySpeakerInfo.rtilCode == id) {
          this.$message({
            type: 'warning',
            message: 'Please to cancel public speaker first, if you want to replace to other pepole.'
          });
          return;
        }
        this.replacePeople(obj);
      }
      if (type == 'muteAudio' || type == 'muteVideo') {
        if (!id) return;
        if (this.rtilCodeKeyTypeVal[id] && (this.rtilCodeKeyTypeVal[id] == 'T' || this.rtilCodeKeyTypeVal[id] == 'R')) {
          const info = {
            partyCode: partyCode,
            rtilCode: id,
            value: val,
            type: type == 'muteAudio' ? 'audio' : 'video'
          };
          // 暂时先用 common party 的接口后面会换掉
          controlDeviceAudioOrVideo(info);
        }
        const params = {
          senderRtilCode: this.userInfo.rtilCode,
          type: type == 'muteAudio' ? 'mic' : 'camera',
          value: val,
          partyCode: this.groupPartyCode,
          toRtilCode: id,
          origin: 'galleryViewHost'
        };
        controlDeviceBehavior(params, res => {
          if (res.data.errorCode === '0x0') {
            let _str = '';
            const sourceType = this.rtilCodeKeyTypeVal[id];
            if (sourceType == 'Web') {
              if (type === 'muteAudio' || type === 'muteVideo' && !val) {
                _str = this.$t('commonFunction.operateSuccessful');
              } else {
                _str = this.$t('kioskHost.requestHasBeenSend');
              }
            } else {
              _str = this.$t('commonFunction.operateSuccessful');
            }
            this.$message({
              type: 'success',
              message: _str
            });
          }
        });
      }
      if (type === 'setBroadcast') {
        if (this.State.galleryBroadcastInfo && this.State.galleryBroadcastInfo.rtilCode == id) return;
        if (this.State.gallerySpeakerInfo && this.State.gallerySpeakerInfo.rtilCode == id) {
          this.$message({
            type: 'warning',
            message: 'Set broadcast failed, because you can only have one role.'
          });
          return;
        }
        if (this.shareRtilCode != '') {
          this.$message({
            type: 'warning',
            message: 'Please stop share screen first.'
          });
          return;
        }
        if (this.groupInfo.outputRid) {
          this.$confirm(this.$t('commonFunction.broadcasterSource'), {
            confirmButtonText: this.$t('commonFunction.switch'),
            cancelButtonText: this.$t('commonFunction.cancel'),
            customClass: 'confirmBox',
            cancelButtonClass: 'cancelBtn',
            confirmButtonClass: 'joinBtn'
          }).then(() => {
            this.setBroadcast(obj);
          }).catch(() => {
            this.$refs[`remoteSource${id}`][0].changeItmeVal('participant');
          });
        } else {
          this.setBroadcast(obj);
        }
      }
      if (type === 'setPublicSpeaker') {
        if (this.State.gallerySpeakerInfo && this.State.gallerySpeakerInfo.rtilCode == id) return;
        this.setSpeaker(obj);
      }
      if (type === 'participant') {
        var _this$State$gallerySp, _this$State$galleryBr;
        if (((_this$State$gallerySp = this.State.gallerySpeakerInfo) === null || _this$State$gallerySp === void 0 ? void 0 : _this$State$gallerySp.rtilCode) == id) this.cancelSpeaker();
        if (((_this$State$galleryBr = this.State.galleryBroadcastInfo) === null || _this$State$galleryBr === void 0 ? void 0 : _this$State$galleryBr.rtilCode) == id) this.cancelBroadcast();
      }
      if (type == 'moveParty') {
        id = String(id);
        if (obj.sign == 'batch') {
          // 批量
          this.batchMovePartyInfo.show = true;
          if (obj.status) {
            if (!this.batchMovePartyInfo.rtilCodes.includes(id)) {
              this.batchMovePartyInfo.rtilCodes.push(id);
            }
          } else {
            this.batchMovePartyInfo.rtilCodes = this.batchMovePartyInfo.rtilCodes.filter(v => v != id);
          }
        } else {
          this.movePartyInfo.show = true;
          this.movePartyInfo.rtilCodes = [String(id)];
        }
      }
      if (type === 'fullScreen') {
        if (val && getFullscreenEnabled()) {
          document.documentElement.requestFullscreen && document.documentElement.requestFullscreen();
        }
      }
      if (type === 'audioContext') {
        this.localVolume = val;
      }
      if (type === 'anyWhereSetting') {
        this.getNickName(id, 'anyWhereSetting');
        this.anyWhereInfo.rtilCode = id;
        this.anyWhereRtilCodeObj = this.channels[id];
        // 置空打开弹窗对应的gallery列表流
        if (this.anyWhereInfo.rtilCode) {
          this.$set(this.channels, id, {});
          this.$set(this.anywhereSettingShowMap, id, true);
        }
        this.vfbVideoInfo = {
          rtilCode: id,
          id: id
        };
        const realPartyCode = partyCode;
        if (this.rtc[realPartyCode]._subscribeTrack[id]) {
          const obj = {};
          obj.id = id;
          obj.channel = partyCode;
          obj.videoTrack = this.rtc[realPartyCode]._subscribeTrack[id].videoTrack;
          obj.audioTrack = this.rtc[realPartyCode]._subscribeTrack[id].audioTrack;
          this.vfbVideoInfo = obj;
        }
      }
      if (type === 'setting') {
        this.deviceDetailInfo.show = true;
        this.detailObj = obj;
      }
      if (type === 'formImageGallery') {
        this.uploadImageInfo.visible = true;
        this.uploadImageInfo.slotIndex = index;
        this.uploadImageInfo.partyCode = partyCode;
      }
      if (type === 'getUploadImageList') {
        this.getUploadImageInfo(partyCode);
      }
    },
    setBroadcast(info) {
      if (this.State.galleryBroadcastInfo) {
        this.$message({
          type: 'warning',
          message: `Please cancel ${this.State.galleryBroadcastInfo.nickName} first, if you want to set other broadcaster`
        });
        return;
      }
      info.remoteStream = null;
      const params = {
        partyCode: this.groupPartyCode,
        module: 'setOutput',
        msg: {
          info,
          rtilCode: info.rtilCode,
          sourceType: 'Participant',
          nickName: info.nickName,
          participantOutputPartyCode: this.chatParty
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=69767', params);
    },
    setSpeaker(info) {
      if (this.State.gallerySpeakerInfo) {
        this.$message({
          type: 'warning',
          message: `Please cancel ${this.State.gallerySpeakerInfo.nickName} first, if you want to set other speaker`
        });
        return;
      }
      info.remoteStream = null;
      const parmas = {
        partyCode: this.groupPartyCode,
        module: 'setSpeaker',
        msg: {
          rtilCode: info.rtilCode,
          nickName: info.nickName,
          info
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=13552', parmas).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message({
            type: 'success',
            message: 'Set speaker success'
          });
        }
      });
    },
    replacePeople(obj) {
      this.replaceInfo = {
        show: true,
        index: obj.index + 1,
        pageNum: this.sendParmas.pageNum,
        groupId: this.State.partyCode,
        originRtilCode: obj.id,
        originRealPartyCode: obj.channel
      };
    },
    pageSerBusCallback({
      socket,
      partyCode
    }) {
      this.wsPageSTimer = setInterval(() => {
        if (!this.$route.name.includes('group') && this.$route.name != 'newGroup') clearInterval(this.wsPageSTimer);
        const rtilCodes = Object.keys(this.allAccountIdByRtilCode);
        const params = {
          data: JSON.stringify({
            data: JSON.stringify({
              rtilCodes: rtilCodes,
              businessId: partyCode
            }),
            module: 'rtilLiveStatus',
            type: 'rtilLiveStatus'
          }),
          serverName: 'partyline'
        };
        if (socket.client.readyState === 1 && this.$route.name.includes('group')) {
          socket.send(params);
        }
      }, 2000);
    },
    getParOnlineNumber({
      socket,
      partyCode
    }) {
      this.onlineNumberTimer = setInterval(() => {
        if (!this.$route.name.includes('group')) clearInterval(this.onlineNumberTimer);
        const array = [];
        this.State.partyCodeList.forEach(item => {
          array.push(item.code);
        });
        const params = {
          data: JSON.stringify({
            data: JSON.stringify({
              partyCodes: array,
              businessId: partyCode
            }),
            module: 'partyOnlineStatus',
            type: 'partyOnlineStatus'
          }),
          serverName: 'partyline'
        };
        if (socket.client.readyState === 1 && this.$route.name.includes('group')) {
          socket.send(params);
        }
      }, 10000);
    },
    cancelOutput() {
      const params = {
        partyCode: this.groupPartyCode,
        module: 'cancelOutput',
        msg: {
          pageNum: this.sendParmas.pageNum,
          sourceType: 'ShareScreen',
          rtilCode: this.shareRtilCode
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=77980', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.groupInfo.outputType = '';
          if (this.groupInfo.galleryMode) return;
          this.sourceType.type = '';
          this.sourceType.sourceType = '';
        }
      });
    },
    showFullScreenCloseBtnFn(val) {
      if (this.initShowCloseFullScreenBtn) return; // 初始化显示3s之后，在执行其他操作
      this.showCloseFullScreenBtn = val;
    },
    moveParty(val, rtilCode) {
      this.attendCallback({
        type: 'moveParty',
        id: rtilCode,
        status: val,
        sign: 'batch'
      });
    },
    clearStatus() {
      this.State.privateInfo = {};
    },
    editTagName(obj) {
      this.setTagName.show = true;
      this.setTagName.originRtilCode = this.userInfo.rtilCode;
      this.setTagName.targetRtilCode = obj.id;
      this.setTagName.partyCode = this.groupPartyCode;
      this.setTagName.tagName = this.tagNameInfo[obj.id];
    },
    saveTagName(obj) {
      this.$set(this.tagNameInfo, obj.rtilCode, obj.tagName);
      if (this.State.gallerySpeakerInfo && this.State.gallerySpeakerInfo.rtilCode == obj.rtilCode) {
        Bus.$emit('changeTagName', obj); // 通知头部更改tagName
      }
    },

    hasRemovePeople(info) {
      const {
        rtilCode,
        partyCode
      } = info;
      this.removeInfo.isRemoving = true;
      this.removeInfo.rtilCode = rtilCode;
      this.removeInfo.partyCode = partyCode;
    },
    updateLayout(layout, id) {
      // 先清空rtilList，避免闪一下
      const array = layout.split('-');
      this.rtilCodeList = [];
      this.State.galleryAllGroupRtilCodes = [];
      const params = {
        id: this.groupId,
        layout: array[0],
        column: array[1],
        layoutName: layout
      };
      this.axios.post('/partyline-backend/group/update', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.sendParmas.pageNum = 1;
          this.State.groupLayout = {
            layout: array[0],
            column: array[1],
            layoutName: layout
          };
          this.State.currentPartyInfo.layout = array[0];
          this.State.currentPartyInfo.column = array[1];
          this.calculatePIpListWidth();
          this.joinPartyLine(true);
          this.$message({
            type: 'success',
            message: this.$t('galleryHost.changeSuccess')
          });
          // 初始化可能可能之前在6x24layout使用的数据
          this.selectRtilCodes = {};
          this.selectModule = '';
          if (layout == '7-7-80-80' || layout == '12-24-80-80' || layout == '6-24-80-80') {
            this.showLeft = false;
            this.showNextPageIcon = false;
          } else {
            this.showLeft = true;
            this.showNextPageIcon = true;
          }
        }
      });
    },
    uploadImageCallback(info) {
      const {
        key,
        partyCode
      } = info;
      switch (key) {
        case 'getUploadList':
          this.getUploadImageInfo(partyCode);
          break;
      }
    },
    getRegion() {
      const localRegion = handleLocalStorage('get', 'region');
      if (localRegion) return;
      this.axios.get('/partyline-backend/user/region').then(res => {
        if (res.data.errorCode === '0x0') {
          handleLocalStorage('set', 'region', res.data.result);
        }
      });
    },
    onlyShowLastFrame(rtilCode) {
      var _this$channels$rtilCo8;
      return rtilCode > 0 && ((_this$channels$rtilCo8 = this.channels[rtilCode]) === null || _this$channels$rtilCo8 === void 0 ? void 0 : _this$channels$rtilCo8.leave);
    },
    showCopyText(rtilCode, index) {
      return this.fillRuleIndex == 4 && rtilCode < 0 && this.slotIndex && !this.State.imagePositionInfo[index];
    },
    showImage(index) {
      return this.State.imagePositionInfo[index] || this.State.uploadingImageInfo[index];
    },
    showLogo(rtilCode, index) {
      return rtilCode < 0 && !this.State.imagePositionInfo[index] && !this.State.uploadingImageInfo[index] && !this.slotIndex;
    },
    returnButtonList(rtilCode, index) {
      // 当前是上传过图片的状态
      if (this.State.imagePositionInfo[index] || this.State.uploadingImageInfo[index]) {
        return [{
          key: 'uploadImage',
          children: ['fromComputer', 'formImageGallery']
        }, 'removeParticipant'];
      } else {
        let operationList = ['replace', {
          key: 'uploadImage',
          children: ['fromComputer', 'formImageGallery']
        }, 'removeParticipant'];
        // 有与会者时不能上传图片
        if (rtilCode > 0) operationList = operationList.filter(item => typeof item === 'string');
        if (rtilCode < 0) operationList.pop();
        if (this.slotIndex && rtilCode < 0) operationList.shift();
        return operationList;
      }
    },
    imageClass(index) {
      if (!this.State.imagePositionInfo[index]) return;
      let className = '';
      const {
        imageWidth,
        imageHeight
      } = this.State.imagePositionInfo[index];
      if (imageWidth && imageHeight) {
        const containerAspect = 16 / 9;
        const imgAspect = imageWidth / imageHeight;
        imgAspect >= containerAspect ? className = 'imageCover' : className = 'imageContain';
      }
      return className;
    }
  },
  async beforeRouteLeave(to, from, next) {
    for (const k in this.rtc) {
      this.rtc[k] && (await this.rtc[k].leave(this.hadOpenWebCloud ? 'closeCLoudProxy' : ''));
    }
    Object.keys(this.sendMetadataTimer).forEach(rtilCode => {
      clearInterval(this.sendMetadataTimer[rtilCode]);
    });
    // 恢复初始设置
    window.removeEventListener('keydown', this.keydownEvent);
    window.removeEventListener('resize', this.calculatePIpListWidth);
    this.State.crewInfo = {};
    this.State.privateInfo = {};
    this.userInfo = {};
    this.PartyLineRequest && this.PartyLineRequest.close();
    this.State.pageSerBusRequestWs[this.groupId] && this.State.pageSerBusRequestWs[this.groupId].close();
    this.$delete(this.State.pageSerBusRequestWs, this.groupId);
    Bus.$off('updateLayout');
    Bus.$off('stopSharing');
    Bus.$off('notify');
    if (this.wsPageSTimer) clearInterval(this.wsPageSTimer);
    if (this.onlineNumberTimer) clearInterval(this.onlineNumberTimer);
    if (this.setTimer) clearTimeout(this.setTimer);
    for (const k in this.rtc) {
      var _this$rtc$k;
      ((_this$rtc$k = this.rtc[k]) === null || _this$rtc$k === void 0 ? void 0 : _this$rtc$k._client) && this.rtc[k].leave();
    }
    next();
  }
};